<template>
    <div class="app has-header">
        <div class="header main">
            <div class="align-left"></div>
            <div class="align-middle">
                <headerbuttonstack :state="headerButtons"/>
            </div>
            <div class="align-right">
                <headerbuttonstack :state="sideButtons"/>
            </div>
        </div>
        <div v-if="!loading && storeSettings" class="scrollbar-container">
            <div style="margin-bottom: 24px;" class="page-settings data-input">
                <div class="content">

                            <div class="full split-bottom">
                                <div class="third left">
                                    <div class="full">
                                        <div class="header">
                                            <div class="label">{{ $t('store.settings.info') }}</div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('pages.employeeData.name') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.name }}</div>
                                            </div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('store.events.description') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.description }}</div>
                                            </div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('pages.employeeData.address') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.address }}</div>
                                            </div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('pages.employeeCoreData.city') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.city }}</div>
                                            </div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('pages.employeeCoreData.postalCode') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.postalCode }}</div>
                                            </div>
                                        </div>
                                        <div class="full" v-if="storeSettings.federalState">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.federalState') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ federalStateMap[storeSettings.federalState] }}</div>
                                            </div>
                                        </div>
                                        <div class="full split-bottom">
                                            <div class="half">
                                                <div class="label">{{ $t('pages.employeeCoreData.country') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ countryMap[storeSettings.country] }}</div>
                                            </div>
                                        </div>



                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{(storeSettings.country == 1 ? this.$t('pages.employeeContract.collectiveContract') : this.$t('pages.employeeContract.contractModel'))}} {{ $t('store.settings.needed') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.collectiveContractRequired? $t('global.ui.yes'):$t('global.ui.no') }}</div>
                                            </div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.strictLawCompliance') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.strictlyLawAbiding? $t('global.ui.yes'):$t('global.ui.no') }}</div>
                                            </div>
                                        </div>
                                        <div class="full" v-if="storeSettings.defaultYouthWorkConfig && youthWorkConfigMap[storeSettings.defaultYouthWorkConfig] && isSuperUser">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.youthWork') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ youthWorkConfigMap[storeSettings.defaultYouthWorkConfig].name }}</div>
                                            </div>
                                        </div>
                                        <div class="full" v-if="storeSettings.allowFutureAssignment == false">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.futureRoster') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.allowFutureAssignment? $t('global.ui.yes'):$t('global.ui.no') }}</div>
                                            </div>
                                        </div>
                                        <div class="full" v-if="isSuperUser">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.market') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ marketTypeMap[storeSettings.marketType].label }}</div>
                                            </div>
                                        </div>
                                        <div class="full" >
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.hideDeactivatedEmps') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.hideDeactivatedEmployees ? $t('global.ui.yes') : $t('global.ui.no') }}</div>
                                            </div>
                                        </div>
                                        <div class="full" >
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.mandatoryNightShift')}}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.nightWorkRequired ? $t('global.ui.yes') : $t('global.ui.no') }}</div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="full">
                                        <div class="header">
                                            <div class="label">{{ $t('store.settings.workingVacation') }}</div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('pages.employeeContract.workDays') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ $helpers.formatWeekDayArray(storeSettings.workDays) }}  </div>
                                            </div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.standardBreak') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.defaultBreakTime }}</div>
                                            </div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.workingTimeModel') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.workTimeMode == 0 ? this.$t('store.settings.average') : (storeSettings.workTimeMode == 1 ? this.$t('store.settings.workingDays') : (storeSettings.workTimeMode == 2 ? this.$tc('store.settings.weekdays', 2) : this.$t('store.settings.workWithoutHolidays'))) }}</div>
                                            </div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.holidayAliquot') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.vacationFactoring == 0 ? $tc('global.general.month', 2) : this.$t('store.settings.calendarDays') }}</div>
                                            </div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.aliquotBasis') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.exitFactoring == 0 ? this.$t('store.settings.calendarMonth') : "30 Tage" }}</div>
                                            </div>
                                        </div>
                                        <div v-if="storeSettings.workTimeMode == 0" class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.monthlyHourFactor') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ (storeSettings.workTimeFactor * Math.pow(10, -7)).toFixed(4) }}</div>
                                            </div>
                                        </div>
                                        <div v-if="storeSettings.enableWorkBalanceMultiplier" class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.calculationFactor') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ (storeSettings.workBalanceMultiplier/100).toFixed(2) }}</div>
                                            </div>
                                        </div>
                                        <div class="full split-bottom" v-if="!storeSettings.separateOvertimeHolidayTime">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.seperateOvertimeHolidays') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.separateOvertimeHolidayTime ? $t('global.ui.yes') : $t('global.ui.no') }}</div>
                                            </div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.maxWorkTime') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.workDayCalcMode == 1 ? $t('store.settings.sameDayWorkingTime') :  $t('store.settings.shiftDayWorkingTime') }}</div>
                                            </div>
                                        </div>
                                        <div class="full" v-if="storeSettings.regularWorkTimeLimit > -1">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.maxWorkTimeExceeded') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.regularWorkTimeLimit+"%" }}</div>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                                <div class="third">
                                    <div class="full">
                                        <div class="header">
                                            <div class="label">{{ $t('store.settings.licenseValid') }}</div>
                                        </div>
                                        <div class="full" v-if="storeSettings.licExpiry != null">
                                            <div class="half">
                                                <div class="label">{{ $t('global.MD') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ $helpers.extractDateStringTZ(storeSettings.licExpiry, "DD.MM.YYYY") }}</div>
                                            </div>
                                        </div>
                                        <div class="full" v-if="storeSettings.mzLicExpiry != null">
                                            <div class="half">
                                                <div class="label">{{ $t('global.MZ') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ $helpers.extractDateStringTZ(storeSettings.mzLicExpiry, "DD.MM.YYYY") }}</div>
                                            </div>
                                        </div>
                                        <div class="full" v-if="storeSettings.mpLicExpiry != null">
                                            <div class="half">
                                                <div class="label">{{ $t('global.MP') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ $helpers.extractDateStringTZ(storeSettings.mpLicExpiry, "DD.MM.YYYY") }}</div>
                                            </div>
                                        </div>
                                        <div class="full" v-if="storeSettings.mlLicExpiry != null">
                                            <div class="half">
                                                <div class="label">{{ $t('global.ML') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ $helpers.extractDateStringTZ(storeSettings.mlLicExpiry, "DD.MM.YYYY") }}</div>
                                            </div>
                                        </div>
                                        <div class="full" v-if="storeSettings.asLicExpiry != null">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.autoPlanning') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ $helpers.extractDateStringTZ(storeSettings.asLicExpiry, "DD.MM.YYYY") }}</div>
                                            </div>
                                        </div>
                                        <div class="full" v-if="storeSettings.statsLicExpiry != null">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.dataAnalysis') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ $helpers.extractDateStringTZ(storeSettings.statsLicExpiry, "DD.MM.YYYY") }}</div>
                                            </div>
                                        </div>
                                        <div class="full" v-if="storeSettings.weatherLicExpiry != null">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.weather') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ $helpers.extractDateStringTZ(storeSettings.weatherLicExpiry, "DD.MM.YYYY") }}</div>
                                            </div>
                                        </div>
                                        <div class="full split-bottom" v-if="storeSettings.hdWeatherLicExpiry != null">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.weatherPro') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ $helpers.extractDateStringTZ(storeSettings.hdWeatherLicExpiry, "DD.MM.YYYY") }}</div>
                                            </div>
                                        </div>
                                        <div class="full split-bottom">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.operationStart') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ $helpers.extractDateStringTZ(storeSettings.usageStartDate, "DD.MM.YYYY") }}</div>
                                            </div>
                                        </div>
                                        <div class="full split-bottom" v-if="storeSettings.simpleMode">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.simpleMode') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.simpleMode ? $t('global.ui.yes') : $t('global.ui.no') }}</div>
                                            </div>
                                        </div>
                                        <div class="full split-bottom">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.inactivityLogout') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.autoLogoutTime > 0 ?  (storeSettings.autoLogoutTime+ ' Minuten') : $t('store.settings.deactivated') }}</div>
                                            </div>
                                        </div>
                                        <div class="full" v-if="isSuperUser">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.deactivated') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.disabled ? $t('global.ui.yes') : $t('global.ui.no') }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="full">
                                        <div class="header">
                                            <div class="label">{{ $t('store.settings.planing') }}</div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.maxPlaningTypes') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.employeeTypeCountMax }}</div>
                                            </div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.maxLeisureOptions') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.employeeRulesCountMax }}</div>
                                            </div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.maxShiftGroups') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.shiftTemplateGroupCountMax }}</div>
                                            </div>
                                        </div>
                                        <div class="full" v-if="storeSettings.lawCheckSpareTimePrefTypes.length > 0">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.nonWeekRest') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ formatEmpApprovablePrefTypesArray(storeSettings.lawCheckSpareTimePrefTypes)}}</div>
                                            </div>
                                        </div>
                                        <div class="full" v-if="storeSettings.lawCheckRestTimePrefTypes.length > 0">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.nonRest') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ formatEmpApprovablePrefTypesArray(storeSettings.lawCheckRestTimePrefTypes)}}</div>
                                            </div>
                                        </div>
                                        <div class="full" v-if="isSuperUser">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.averageAbsenceWorking') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.useAvgWorkTimeForPrefs ? $t('global.ui.yes') : $t('global.ui.no') }}</div>
                                            </div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.multiShifting') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.allowMultiShiftAssign? $t('global.ui.yes') : $t('global.ui.no') }}</div>
                                            </div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.shiftOvertime') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.allowShiftOvertime? $t('global.ui.yes') : $t('global.ui.no').toUpperCase() + ' ('+(storeSettings.shiftOvertimeOverride > 0 ? (storeSettings.shiftOvertimeOverride/60.0).toFixed(2)+'h' : 'Vertrag')+')' }}</div>
                                            </div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.weekOvertime') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.allowWeeklyOvertime? $t('global.ui.yes') : $t('global.ui.no').toUpperCase() + ' ('+(storeSettings.weekOvertimeOverride > 0 ? (storeSettings.weekOvertimeOverride/60.0).toFixed(2)+'h' : 'Vertrag')+')' }}</div>
                                            </div>
                                        </div>



                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.mpEmployeeLevel') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ employeeLevelMap[storeSettings.maxEmployeeLevelToMp].label }}</div>
                                            </div>
                                        </div>

                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.meo') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.enableMeo ? $t('global.ui.yes') : $t('global.ui.no') }}</div>
                                            </div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.vlh') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.enableVlh ? $t('global.ui.yes') : $t('global.ui.no') }}</div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="third right">
                                    <div class="full">
                                        <div class="header">
                                            <div class="label">{{ $t('store.settings.appSettings') }}</div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.contactNotifications') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.allowContactPersonMessage? $t('global.ui.yes') : $t('global.ui.no') }}</div>
                                            </div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.wishOnApp') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.allowAppEmployeePreferences? $t('global.ui.yes') : $t('global.ui.no') }}</div>
                                            </div>
                                        </div>
                                        <div class="full" v-if="storeSettings.allowAppEmployeePreferences">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.confirmAppWishes') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.unapproveAppEmployeePreferences? $t('global.ui.yes') : $t('global.ui.no') }}</div>
                                            </div>
                                        </div>
                                        <div class="full" v-if="storeSettings.allowAppEmployeePreferences">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.wishesPerMonth') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.maxAppEmployeePreferences }}</div>
                                            </div>
                                        </div>

                                        <div class="full" v-if="storeSettings.allowAppEmployeePreferences">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.wishDeadline') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.enableAppEmployeePreferencesDeadline? $t('global.ui.yes') : $t('global.ui.no') }}</div>
                                            </div>
                                        </div>
                                        <div class="full" v-if="storeSettings.enableAppEmployeePreferencesDeadline && storeSettings.allowAppEmployeePreferences && storeSettings.appEmployeePreferencesDeadlineType == 1">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.wishDeadlineDate') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.appEmployeePreferencesDeadline }}</div>
                                            </div>
                                        </div>
                                        <div class="full" v-if="storeSettings.enableAppEmployeePreferencesDeadline && storeSettings.allowAppEmployeePreferences && storeSettings.appEmployeePreferencesDeadlineType == 2">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.wishDeadlineDays') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.appEmployeePreferencesDeadline }}</div>
                                            </div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.vacateOnApp') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.allowAppVacationRequests? $t('global.ui.yes') : $t('global.ui.no') }}</div>
                                            </div>
                                        </div>
                                        <div class="full" v-if="isSuperUser">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.shiftDeniesOnApp') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.enableAppShiftStatus? $t('global.ui.yes') : $t('global.ui.no') }}</div>
                                            </div>
                                        </div>
                                        <div class="full" v-if="storeSettings.empApprovablePrefTypes.length == 0">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.employeeConfirmAbsence') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ $t('global.ui.no').toUpperCase() }}  </div>
                                            </div>
                                        </div>
                                        <div class="full" v-else>
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.employeeConfirmAbsence') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ formatEmpApprovablePrefTypesArray(storeSettings.empApprovablePrefTypes) }}  </div>
                                            </div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.showBalanceInApp') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.enableAppBalanceDisplay ? $t('global.ui.yes') : $t('global.ui.no') }}</div>
                                            </div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.showHolidayHoursInApp') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.enableAppHolidayTimeDisplay ? $t('global.ui.yes') : $t('global.ui.no') }}</div>
                                            </div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.showOvertimeInApp') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.enableAppOverTimeDisplay ? $t('global.ui.yes') : $t('global.ui.no') }}</div>
                                            </div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.seePayInApp') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.enableAppEmployeePaymentDisplay ? $t('global.ui.yes') : $t('global.ui.no') }}</div>
                                            </div>
                                        </div>
                                        <div class="full">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.commentOutOfShift') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.requireActualShiftComment ? $t('global.ui.yes') : $t('global.ui.no') }}</div>
                                            </div>
                                        </div>
                                        <div v-if="isSuperUser" class="full split-bottom">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.betaChat') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ storeSettings.enableAppChat ? $t('global.ui.yes') : $t('global.ui.no') }}</div>
                                            </div>
                                        </div>

                                        <div v-if="showMap" style="height: 230px;" class="full">
                                            <div style="margin-bottom: 4px;" class="label">{{ $t('store.settings.autoWeatherLocation') }}</div>
                                            <heremap ref="storelocationmap" :lat="storeSettings.latitude" :lng="storeSettings.longitude" width="100%" height="200px" :showPositionMarker="true" :interactive="true" :picker="false"/>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="half left">
                                <div class="header">
                                    <div class="label">{{ $t('store.settings.sotecWebcockpitConfig') }}</div>
                                </div>
                                <div v-if="sotecWebcockpitConfig != null" class="full">
                                    <div class="full">

                                        <div class="full split-bottom-tight">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.sotecStoreId') }}</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ sotecWebcockpitConfig.intStoreId }}</div>
                                            </div>
                                            <div class="half">
                                                <div class="label">API Key:</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">****************</div>
                                            </div>
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.allowDataAccess') }}:</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ sotecWebcockpitConfig.allowRead ? $t('global.ui.yes') : $t('global.ui.no') }}</div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div v-else class="full">
                                    <div class="half">
                                        <div class="label">{{ $t('store.settings.webcockpitNotConnected') }}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="hasSharepointLicense" class="half right">
                                <div class="header">
                                    <div class="label">{{ $t('store.settings.sharepointConfig') }}</div>
                                </div>
                                <div v-if="hasSharepointConfig" class="full">
                                    <div class="full">
                                        <div class="full split-bottom-tight">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.username') }}:</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ sharepointConfig.username }}</div>
                                            </div>
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.password') }}:</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">****************</div>
                                            </div>
                                        </div>
                                        <div class="full split-bottom-tight">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.clientId') }}:</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ sharepointConfig.data.map.client_id }}</div>
                                            </div>
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.clientSecret') }}:</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">****************</div>
                                            </div>
                                        </div>
                                        <div class="full split-bottom-tight">
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.tenantId') }}:</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ sharepointConfig.data.map.tenant_id }}</div>
                                            </div>
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.driveId') }}:</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ $helpers.truncate(sharepointConfig.data.map.driveId, 38) }}</div>
                                            </div>
                                            <div class="half">
                                                <div class="label">{{ $t('store.settings.personalOrderId') }}:</div>
                                            </div>
                                            <div class="half right float">
                                                <div class="label data">{{ sharepointConfig.data.map.rootFolderId }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="full">
                                    <div class="half">
                                        <div class="label">{{ $t('store.settings.sharepointConfigNotFound') }}</div>
                                    </div>
                                </div>
                                <div style="height: 48px;">&nbsp;</div>
                            </div>
                        </div>
            </div>
        </div>

        <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>
            <br/>
            <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                <div style="background-color: #aaa; border: 2px solid #777; color: #444; margin-top: 140px; height: 60px; line-height: 30px; font-size: 14px; border-radius: 12px; padding: 13px;">
                    {{ loadingText }}
                </div>
            </div>
        </div>

        <div class="discarder" v-if="modalImportCsv"
             @click="modalImportCsv = false;">
        </div>

        <div class="md-card" v-if="modalImportCsv">
            <h6 class="md-card-header" style="text-align: left">
                Store Daten Import
                <i class="fas fa-times" style="float: right"
                   @click="modalImportCsv = false"></i>
            </h6>
            <div class="md-card-body">
                <div class="md-card-select">
                    <p> {{ $t('store.settings.importDataQuery') }}</p>
                    <p> {{ $t('store.settings.importDataHelp') }}</p>
                </div>
                <div class="md-card-select">
                    <input type="file" id="file" accept=".csv" @change="fileSelected" :placeholder="$t('store.settings.selectFile')" ref="file-input">
                </div>
            </div>
            <div class="right mright35">
                <buttonc type="no-border red" :label="$t('global.ui.cancel')"
                         @click="modalImportCsv = false" />
                <buttonc type="no-border green" :label="'OK'"
                         @click="importExcelPayload" />
            </div>
        </div>

        <div class="md-card xl" v-if="modalImportSharepoint">
            <h6 class="md-card-header" style="text-align: left">
                {{ $t('store.settings.sharepointConfig') }}
                <i class="fas fa-times" style="float: right"
                   @click="modalImportSharepoint = false"></i>
            </h6>
            <div v-if="!loading">
                <div class="md-card-body">
                    <div class="md-card-select noborder">
                        <div class="cd-input">
                            <labelc type="header" class="label" :text="$t('store.settings.username')"/>
                            <div class="cd-input">
                                <input id="cgfield01" v-model="sharepointSettings.username" step="1"
                                       type="text"/>
                            </div>
                        </div>
                        <div class="cd-input">
                            <labelc type="header" class="label" :text="$t('store.settings.password')"/>
                            <div class="cd-input">
                                <input id="cgfield02" v-model="sharepointSettings.password"
                                       type="password"/>
                            </div>
                        </div>
                        <div class="cd-input">
                            <labelc type="header" class="label" :text="$t('store.settings.clientId')"/>
                            <div class="cd-input">
                                <input id="cgfield03" v-model="sharepointSettings.data.map.client_id"
                                       type="text"/>
                            </div>
                        </div>
                        <div class="cd-input">
                            <labelc type="header" class="label" :text="$t('store.settings.clientSecret')"/>
                            <div class="cd-input">
                                <input id="cgfield04" v-model="sharepointSettings.data.map.client_secret"
                                       type="text"/>
                            </div>
                        </div>
                        <div class="cd-input">
                            <labelc type="header" class="label" :text="$t('store.settings.tenantId')"/>
                            <div class="cd-input">
                                <input id="cgfield05" v-model="sharepointSettings.data.map.tenant_id"
                                       type="text"/>
                            </div>
                        </div>
                        <div class="cd-input">
                            <labelc type="header" class="label" :text="$t('store.settings.driveId')"/>
                            <div class="cd-input">
                                <input id="cgfield06" v-model="sharepointSettings.data.map.driveId"
                                       type="text"/>
                            </div>
                        </div>
                        <div class="cd-input">
                            <labelc type="header" class="label" :text="$t('store.settings.personalOrderId')"/>
                            <div class="cd-input">
                                <input id="cgfield07" v-model="sharepointSettings.data.map.rootFolderId"
                                       type="text"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right mright35">
                    <buttonc type="no-border red" :label="$t('global.ui.cancel')"
                             @click="modalImportSharepoint = false"/>
                    <buttonc type="no-border green" :label="'OK'"
                             @click="editSharepointSettings"/>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { mapState, mapGetters } from 'vuex';
import heremap from "../uicomponents/maps/heremap.vue"

export default {
    name: 'storesettings',
    components: {
        heremap
    },
    data () {
        return {
            loading: false,
            loadingText: '',
            modalImportCsv: false,
            modalImportSharepoint: false,
            sharepointSettings: {
                'username': '',
                'password': '',
                'data': {
                    'map': {
                        "tenant_id": '',
                        "client_id": '',
                        "client_secret": '',
                        "driveId": '',
                        "rootFolderId": ''
                    }
                }
            },
            showMap: false,
            externalDataMap: {},
            sotecApiDataMap: {},
            planningIndicatorTypeMap: {},
            editingSharepointSettings: false,
            transferring: false,
            excelPayloadFile: null,
            workTimeModes: [{label: this.$t('store.settings.average'), value: 0}, {label: this.$t('store.settings.workingDays'), value: 1}, {label: this.$tc('store.settings.weekdays', 2), value: 2}, {label: this.$t('store.settings.workWithoutHolidays'), value: 3}],
            workDayCalcModes: [{label: this.$t('store.settings.sameDayWorkingTime'), value: 1}, {label: this.$t('store.settings.shiftDayWorkingTime'), value: 2}],
            vacationFactoringModes: [{label: this.$tc('global.general.month', 2), value: 0}, {label: this.$t('store.settings.calendarDays'), value: 1}],
            exitFactoringModes: [{label: this.$t('store.settings.calendarMonth'), value: 0}, {label: "30 Tage", value: 1}],
            timeZones: [ "Africa/Abidjan", "Africa/Accra", "Africa/Addis_Ababa", "Africa/Algiers", "Africa/Asmara", "Africa/Asmera", "Africa/Bamako", "Africa/Bangui", "Africa/Banjul", "Africa/Blantyre", "Africa/Brazzaville", "Africa/Bujumbura", "Africa/Cairo", "Africa/Casablanca", "Africa/Ceuta", "Africa/Conakry", "Africa/Dakar", "Africa/Dar_es_Salaam", "Africa/Djibouti", "Africa/Douala", "Africa/El_Aaiun", "Africa/Freetown", "Africa/Gaborone", "Africa/Harare", "Africa/Johannesburg", "Africa/Juba", "Africa/Kampala", "Africa/Khartoum", "Africa/Kigali", "Africa/Kinshasa", "Africa/Lagos", "Africa/Libreville", "Africa/Lome", "Africa/Luanda", "Africa/Lubumbashi", "Africa/Lusaka", "Africa/Malabo", "Africa/Maputo", "Africa/Maseru", "Africa/Mbabane", "Africa/Mogadishu", "Africa/Monrovia", "Africa/Nairobi", "Africa/Ndjamena", "Africa/Niamey", "Africa/Nouakchott", "Africa/Ouagadougou", "Africa/Porto-Novo", "Africa/Sao_Tome", "Africa/Timbuktu", "Africa/Tripoli", "Africa/Tunis", "Africa/Windhoek", "America/Adak", "America/Anchorage", "America/Anguilla", "America/Antigua", "America/Araguaina", "America/Argentina/Buenos_Aires", "America/Argentina/Catamarca", "America/Argentina/ComodRivadavia", "America/Argentina/Cordoba", "America/Argentina/Jujuy", "America/Argentina/La_Rioja", "America/Argentina/Mendoza", "America/Argentina/Rio_Gallegos", "America/Argentina/Salta", "America/Argentina/San_Juan", "America/Argentina/San_Luis", "America/Argentina/Tucuman", "America/Argentina/Ushuaia", "America/Aruba", "America/Asuncion", "America/Atikokan", "America/Atka", "America/Bahia", "America/Bahia_Banderas", "America/Barbados", "America/Belem", "America/Belize", "America/Blanc-Sablon", "America/Boa_Vista", "America/Bogota", "America/Boise", "America/Buenos_Aires", "America/Cambridge_Bay", "America/Campo_Grande", "America/Cancun", "America/Caracas", "America/Catamarca", "America/Cayenne", "America/Cayman", "America/Chicago", "America/Chihuahua", "America/Coral_Harbour", "America/Cordoba", "America/Costa_Rica", "America/Creston", "America/Cuiaba", "America/Curacao", "America/Danmarkshavn", "America/Dawson", "America/Dawson_Creek", "America/Denver", "America/Detroit", "America/Dominica", "America/Edmonton", "America/Eirunepe", "America/El_Salvador", "America/Ensenada", "America/Fort_Wayne", "America/Fortaleza", "America/Glace_Bay", "America/Godthab", "America/Goose_Bay", "America/Grand_Turk", "America/Grenada", "America/Guadeloupe", "America/Guatemala", "America/Guayaquil", "America/Guyana", "America/Halifax", "America/Havana", "America/Hermosillo", "America/Indiana/Indianapolis", "America/Indiana/Knox", "America/Indiana/Marengo", "America/Indiana/Petersburg", "America/Indiana/Tell_City", "America/Indiana/Valparaiso", "America/Indiana/Vevay", "America/Indiana/Vincennes", "America/Indiana/Winamac", "America/Indianapolis", "America/Inuvik", "America/Iqaluit", "America/Jamaica", "America/Jujuy", "America/Juneau", "America/Kentucky/Louisville", "America/Kentucky/Monticello", "America/Knox_IN", "America/Kralendijk", "America/La_Paz", "America/Lima", "America/Los_Angeles", "America/Louisville", "America/Lower_Princes", "America/Maceio", "America/Managua", "America/Manaus", "America/Marigot", "America/Martinique", "America/Matamoros", "America/Mazatlan", "America/Mendoza", "America/Menominee", "America/Merida", "America/Metlakatla", "America/Mexico_City", "America/Miquelon", "America/Moncton", "America/Monterrey", "America/Montevideo", "America/Montreal", "America/Montserrat", "America/Nassau", "America/New_York", "America/Nipigon", "America/Nome", "America/Noronha", "America/North_Dakota/Beulah", "America/North_Dakota/Center", "America/North_Dakota/New_Salem", "America/Ojinaga", "America/Panama", "America/Pangnirtung", "America/Paramaribo", "America/Phoenix", "America/Port_of_Spain", "America/Port-au-Prince", "America/Porto_Acre", "America/Porto_Velho", "America/Puerto_Rico", "America/Rainy_River", "America/Rankin_Inlet", "America/Recife", "America/Regina", "America/Resolute", "America/Rio_Branco", "America/Rosario", "America/Santa_Isabel", "America/Santarem", "America/Santiago", "America/Santo_Domingo", "America/Sao_Paulo", "America/Scoresbysund", "America/Shiprock", "America/Sitka", "America/St_Barthelemy", "America/St_Johns", "America/St_Kitts", "America/St_Lucia", "America/St_Thomas", "America/St_Vincent", "America/Swift_Current", "America/Tegucigalpa", "America/Thule", "America/Thunder_Bay", "America/Tijuana", "America/Toronto", "America/Tortola", "America/Vancouver", "America/Virgin", "America/Whitehorse", "America/Winnipeg", "America/Yakutat", "America/Yellowknife", "Antarctica/Casey", "Antarctica/Davis", "Antarctica/DumontDUrville", "Antarctica/Macquarie", "Antarctica/Mawson", "Antarctica/McMurdo", "Antarctica/Palmer", "Antarctica/Rothera", "Antarctica/South_Pole", "Antarctica/Syowa", "Antarctica/Troll", "Antarctica/Vostok", "Arctic/Longyearbyen", "Asia/Aden", "Asia/Almaty", "Asia/Amman", "Asia/Anadyr", "Asia/Aqtau", "Asia/Aqtobe", "Asia/Ashgabat", "Asia/Ashkhabad", "Asia/Baghdad", "Asia/Bahrain", "Asia/Baku", "Asia/Bangkok", "Asia/Beirut", "Asia/Bishkek", "Asia/Brunei", "Asia/Calcutta", "Asia/Choibalsan", "Asia/Chongqing", "Asia/Chungking", "Asia/Colombo", "Asia/Dacca", "Asia/Damascus", "Asia/Dhaka", "Asia/Dili", "Asia/Dubai", "Asia/Dushanbe", "Asia/Gaza", "Asia/Harbin", "Asia/Hebron", "Asia/Ho_Chi_Minh", "Asia/Hong_Kong", "Asia/Hovd", "Asia/Irkutsk", "Asia/Istanbul", "Asia/Jakarta", "Asia/Jayapura", "Asia/Jerusalem", "Asia/Kabul", "Asia/Kamchatka", "Asia/Karachi", "Asia/Kashgar", "Asia/Kathmandu", "Asia/Katmandu", "Asia/Khandyga", "Asia/Kolkata", "Asia/Krasnoyarsk", "Asia/Kuala_Lumpur", "Asia/Kuching", "Asia/Kuwait", "Asia/Macao", "Asia/Macau", "Asia/Magadan", "Asia/Makassar", "Asia/Manila", "Asia/Muscat", "Asia/Nicosia", "Asia/Novokuznetsk", "Asia/Novosibirsk", "Asia/Omsk", "Asia/Oral", "Asia/Phnom_Penh", "Asia/Pontianak", "Asia/Pyongyang", "Asia/Qatar", "Asia/Qyzylorda", "Asia/Rangoon", "Asia/Riyadh", "Asia/Saigon", "Asia/Sakhalin", "Asia/Samarkand", "Asia/Seoul", "Asia/Shanghai", "Asia/Singapore", "Asia/Taipei", "Asia/Tashkent", "Asia/Tbilisi", "Asia/Tehran", "Asia/Tel_Aviv", "Asia/Thimbu", "Asia/Thimphu", "Asia/Tokyo", "Asia/Ujung_Pandang", "Asia/Ulaanbaatar", "Asia/Ulan_Bator", "Asia/Urumqi", "Asia/Ust-Nera", "Asia/Vientiane", "Asia/Vladivostok", "Asia/Yakutsk", "Asia/Yekaterinburg", "Asia/Yerevan", "Atlantic/Azores", "Atlantic/Bermuda", "Atlantic/Canary", "Atlantic/Cape_Verde", "Atlantic/Faeroe", "Atlantic/Faroe", "Atlantic/Jan_Mayen", "Atlantic/Madeira", "Atlantic/Reykjavik", "Atlantic/South_Georgia", "Atlantic/St_Helena", "Atlantic/Stanley", "Australia/ACT", "Australia/Adelaide", "Australia/Brisbane", "Australia/Broken_Hill", "Australia/Canberra", "Australia/Currie", "Australia/Darwin", "Australia/Eucla", "Australia/Hobart", "Australia/LHI", "Australia/Lindeman", "Australia/Lord_Howe", "Australia/Melbourne", "Australia/North", "Australia/NSW", "Australia/Perth", "Australia/Queensland", "Australia/South", "Australia/Sydney", "Australia/Tasmania", "Australia/Victoria", "Australia/West", "Australia/Yancowinna", "Brazil/Acre", "Brazil/DeNoronha", "Brazil/East", "Brazil/West", "Canada/Atlantic", "Canada/Central", "Canada/Eastern", "Canada/East-Saskatchewan", "Canada/Mountain", "Canada/Newfoundland", "Canada/Pacific", "Canada/Saskatchewan", "Canada/Yukon", "Chile/Continental", "Chile/EasterIsland", "Cuba", "Egypt", "Eire", "Etc/GMT", "Etc/GMT+0", "Etc/UCT", "Etc/Universal", "Etc/UTC", "Etc/Zulu", "Europe/Amsterdam", "Europe/Andorra", "Europe/Athens", "Europe/Belfast", "Europe/Belgrade", "Europe/Berlin", "Europe/Bratislava", "Europe/Brussels", "Europe/Bucharest", "Europe/Budapest", "Europe/Busingen", "Europe/Chisinau", "Europe/Copenhagen", "Europe/Dublin", "Europe/Gibraltar", "Europe/Guernsey", "Europe/Helsinki", "Europe/Isle_of_Man", "Europe/Istanbul", "Europe/Jersey", "Europe/Kaliningrad", "Europe/Kiev", "Europe/Lisbon", "Europe/Ljubljana", "Europe/London", "Europe/Luxembourg", "Europe/Madrid", "Europe/Malta", "Europe/Mariehamn", "Europe/Minsk", "Europe/Monaco", "Europe/Moscow", "Europe/Nicosia", "Europe/Oslo", "Europe/Paris", "Europe/Podgorica", "Europe/Prague", "Europe/Riga", "Europe/Rome", "Europe/Samara", "Europe/San_Marino", "Europe/Sarajevo", "Europe/Simferopol", "Europe/Skopje", "Europe/Sofia", "Europe/Stockholm", "Europe/Tallinn", "Europe/Tirane", "Europe/Tiraspol", "Europe/Uzhgorod", "Europe/Vaduz", "Europe/Vatican", "Europe/Vienna", "Europe/Vilnius", "Europe/Volgograd", "Europe/Warsaw", "Europe/Zagreb", "Europe/Zaporozhye", "Europe/Zurich", "GB", "GB-Eire", "GMT", "GMT+0", "GMT0", "GMT-0", "Greenwich", "Hongkong", "Iceland", "Indian/Antananarivo", "Indian/Chagos", "Indian/Christmas", "Indian/Cocos", "Indian/Comoro", "Indian/Kerguelen", "Indian/Mahe", "Indian/Maldives", "Indian/Mauritius", "Indian/Mayotte", "Indian/Reunion", "Iran", "Israel", "Jamaica", "Japan", "Kwajalein", "Libya", "Mexico/BajaNorte", "Mexico/BajaSur", "Mexico/General", "Navajo", "NZ", "NZ-CHAT", "Pacific/Apia", "Pacific/Auckland", "Pacific/Chatham", "Pacific/Chuuk", "Pacific/Easter", "Pacific/Efate", "Pacific/Enderbury", "Pacific/Fakaofo", "Pacific/Fiji", "Pacific/Funafuti", "Pacific/Galapagos", "Pacific/Gambier", "Pacific/Guadalcanal", "Pacific/Guam", "Pacific/Honolulu", "Pacific/Johnston", "Pacific/Kiritimati", "Pacific/Kosrae", "Pacific/Kwajalein", "Pacific/Majuro", "Pacific/Marquesas", "Pacific/Midway", "Pacific/Nauru", "Pacific/Niue", "Pacific/Norfolk", "Pacific/Noumea", "Pacific/Pago_Pago", "Pacific/Palau", "Pacific/Pitcairn", "Pacific/Pohnpei", "Pacific/Ponape", "Pacific/Port_Moresby", "Pacific/Rarotonga", "Pacific/Saipan", "Pacific/Samoa", "Pacific/Tahiti", "Pacific/Tarawa", "Pacific/Tongatapu", "Pacific/Truk", "Pacific/Wake", "Pacific/Wallis", "Pacific/Yap", "Poland", "Portugal", "PRC", "ROC", "ROK", "Singapore", "Turkey", "UCT", "Universal", "US/Alaska", "US/Aleutian", "US/Arizona", "US/Central", "US/Eastern", "US/East-Indiana", "US/Hawaii", "US/Indiana-Starke", "US/Michigan", "US/Mountain", "US/Pacific", "US/Samoa", "UTC", "W-SU", "Zulu"]

        }
    },
    created: function () {
        if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
            this.refresh();
        }
    },
    computed: {
        ...mapGetters(['storeId', 'isSuperUser', 'externalServicesMap', 'storeSettings', 'uiDataMap', 'selectableStores', 'youthWorkConfigMap']),
        timeZoneList() {
            let result = [];
            this.timeZones.forEach(i => {
                let item = {label: i, value: i};
                result.push(item);
            })
            return result;
        },
        countryList() {
            let result = [];
            this.uiDataMap.countries.forEach(i => {
                let item = {label: i.label_de, value: i.id};
                result.push(item);
            })
            return result;
        },
        countryMap() {
            let map = {};
            this.uiDataMap.countries.forEach(item => map[item.id] = item.label_de);
            return map;
        },
        federalStateList(){
            let result = [];
            this.uiDataMap.federalStates.forEach(i => {
                let item = {label: i.label_de, value: i.id, country: i.countryId};
                result.push(item);
            })
            return result;
        },
        federalStateMap() {
            let map = {};
            this.uiDataMap.federalStates.forEach(item => map[item.id] = item.label_de);
            return map;
        },
        marketTypeMap() {
            let map = {};
            this.uiDataMap.marketTypes.forEach(type => {
                let item = {label: type.label_de, value: type.id};
                map[type.id] = item;
            })
            return map;
        },
        hasSharepointLicense(){
            // TODO: Sharepoint should be a separate license for future customers, show only for Köck Stores
            return this.$store.state.storeId == 74 || this.$store.state.storeId == 76;
        },
        hasSharepointConfig(){
            let sid = null;
            let hasConfig = false;
            Object.values(this.externalServicesMap).forEach((s) => {
                if(s.name == "Microsoft Sharepoint") sid = s.id;
            });
            console.log(this.externalDataMap);
            if(sid != null){
                Object.values(this.externalDataMap).forEach((ed) => {
                    if(ed.externalServiceId == sid) hasConfig = true;
                });
            }
            return hasConfig;
        },
        sharepointConfig(){
            let sid = this.sharepointServiceId;
            let config = {
                'username': '',
                'password': '',
                'data': {
                    'map': {
                        "tenant_id": '',
                        "client_id": '',
                        "client_secret": '',
                        "driveId": '',
                        "rootFolderId": ''
                    }
                }
            };
            if(sid != null){
                Object.values(this.externalDataMap).forEach((ed) => {
                    if(ed.externalServiceId == sid) config = ed;
                });
            }
            return config;
        },
        sharepointServiceId(){
            let sid = null;
            Object.values(this.externalServicesMap).forEach((s) => {
                if(s.name == "Microsoft Sharepoint") sid = s.id;
            });
            return sid;
        },
        sotecWebcockpitConfig(){

            let config = null;
            const data = Object.values(this.sotecApiDataMap);
            if(data.length > 0){
                config = data[0];
            }
            return config;
        },
        employeeLevelMap() {
            let map = {};
            this.uiDataMap.employeeLevels.forEach(level => {
                let item = {label: level.label_de, value: level.id};
                map[level.id] = item;
            })
            return map;
        },
        headerButtons() {
            let view = this;
            let helperLinks = [];
            let buttons = [
                {
                    classes: "edit-settings",
                    type: "block green",
                    disabled: false,
                    icon: "fa-edit",
                    click: ($event) => {
                        this.OpenEditPopup($event, this.storeSettings);
                        //this.openNewBusinessUnitPopup($event);
                    },
                    show:  true,
                    tooltip: this.$t('store.settings.editConfig'),
                    title: this.$t('store.settings.editConfig'),
                    helperText: this.$t('store.settings.editConfigHelp'),
                    //externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/1134428161"
                },
                {
                    classes: "refresh-location",
                    type: "block cyan",
                    disabled: false,
                    icon: "fa-map-marked-alt",
                    click: ($event) => {
                        this.refreshStoreLocation();
                        //this.openNewBusinessUnitPopup($event);
                    },
                    show:  true,
                    tooltip: this.$t('store.settings.editStoreAddress'),
                    title: this.$t('store.settings.editStoreAddress'),
                    helperText: this.$t('store.settings.editStoreAddressHelp'),
                    //externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/1134428161"
                },
                {
                    classes: "excel-import",
                    type: "block",
                    disabled: false,
                    icon: "fa-file-excel",
                    tooltip: this.$t('store.settings.excelImport'),
                    click: ($event) => {
                        this.openExcelImportModal();
                    },
                    show:  this.isSuperUser,
                },
                {
                    classes: "storedata-reset",
                    type: "block",
                    disabled: false,
                    icon: "fa-minus-circle",
                    tooltip: this.$t('store.settings.deleteStoreData'),
                    click: ($event) => {
                        this.openClearStoreDataModal($event);
                    },
                    show:  this.isSuperUser,
                },
                {
                    classes: "usagestartdate-reset",
                    type: "block",
                    disabled: false,
                    icon: "fa-stopwatch",
                    tooltip: this.$t('store.settings.startDataReset'),
                    click: ($event) => {
                        this.OpenResetUsageStartDatePopup($event);
                    },
                    show: this.isSuperUser,
                },
                {
                    classes: "toggle-lawabiding",
                    type: "block",
                    disabled: false,
                    icon: "fa-balance-scale",
                    tooltip: this.$t('store.settings.changeLegalCompliance'),
                    click: ($event) => { this.updateLawAbiding();},
                    show: this.isSuperUser,
                },
                {
                    classes: "toggle-lawabiding",
                    type: "block",
                    disabled: false,
                    icon: "fa-piggy-bank",
                    tooltip: this.$t('store.settings.simpleMode') + ' Switch',
                    click: ($event) => { this.updateSimpleMode();},
                    show: this.isSuperUser,
                },
                {
                    classes: "employee-transfer",
                    type: "block orange ",
                    icon: "fa-exchange-alt",
                    click: () => { this.openTransferModal(); },
                    tooltip: this.$t('store.settings.dataTransfer'),
                    title: this.$t('store.settings.dataTransfer'),
                    helperText: this.$t('store.settings.copyStoreData'),
                    disabled: this.transferring,
                    show: true,
                },
                {
                    classes: "employee-unlink",
                    type: "block red ",
                    icon: "fa-unlink",
                    click: () => { this.openUnlinkAccountsModal(); },
                    tooltip: this.$t('store.settings.unlinkEmployeeAccounts'),
                    title: this.$t('store.settings.unlinkEmployeeAccounts'),
                    helperText: this.$t('store.settings.unlinkEmployeeAccounts'),
                    show: this.isSuperUser,
                },
            ];
            let state = {
                buttons: buttons,
                helperLinks: helperLinks,
                showListIconAlways: true
            };

            state.helperLinks = [
                {
                    icon: "fa-video",
                    title: this.$t('store.structure.watchTrainingVideo'),
                    helperText: this.$t('store.structure.watchTrainingVideoHelp'),
                    externalUrl: "https://www.youtube.com/watch_popup?v=ES15Y5i5vKU",
                    externalLabel: this.$t('store.structure.watchTrainingVideoLabel'),
                    cancelLabel: this.$t('global.ui.close'),
                },
                {
                    title:  this.$t('store.structure.getSupport'),
                    helperText:  this.$t('store.structure.getSupportHelp'),
                    externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/16",
                    externalLabel:  this.$t('store.structure.getSupportLabel'),
                    cancelLabel: this.$t('global.ui.close'),
                }
            ];
            return state;
        },
        sideButtons() {
            let view = this;

            let state= {
                buttons: []
            };
            state.buttons.push({
                type: "block",
                icon: "fa-bars",
                click: ($event) => {view.OpenDisplayMenuDetails($event)}
            });

            return state;
        },
        burgermenuState(){
            let view = this;
            let state = {};

            state = {
                componentref: 'burgermenustate',
                groups: [

                ],
                items: []
            };
            let group1 = {
                label: this.$t('store.settings.additionalSettings'),
                items: [

                    {
                        closeOnClick: true,
                        icon: "fa-cog",
                        text: this.$t('store.settings.sotecWebcockpit'),
                        disabled: false,
                        click: () => { view.OpenEditSotecWebcockpitSettingsPopup(view.sotecWebcockpitConfig == null);}
                    },
                    {
                        closeOnClick: true,
                        disabled: !this.hasSharepointLicense,
                        icon: "fa-cog",
                        click: () => { view.openEditSharepointSettingsModal(view.hasSharepointConfig); },
                        text: 'Microsoft Sharepoint',

                    },
                    {
                        closeOnClick: true,
                        disabled: !(this.hasSharepointLicense && this.hasSharepointConfig),
                        icon: "fa-cog",
                        click: () => { view.ToggleAutoCalcMulti(); },
                        text: this.$t('store.settings.testSharepoint'),
                    },

                ]
            }



            state.groups.push(group1);


            return state;
        },
    },
    watch: {
        storeId: function(val, oldVal) {
            this.refresh();
        },
    },
    // methods that implement data logic.
    methods: {
        refresh: function(force = false){
            let view = this;
            view.loading = true;
            view.$helpers.GetUiDataMap(force).then(response => {
                return view.$helpers.GetStoreSettings(force);
            }).then(response => {
                return view.$helpers.GetYouthWorkConfigMap(force);
            }).then(response => {
                return view.loadPlanningIndicatorTypes();
            }).then(response => {
                view.updatePlanningIndicatorTypes(response.data);
                return view.loadSotecApiData();
            }).then(response => {
                view.updateSotecApiData(response.data);
                return view.loadStoreExternalData();
            }).then(response => {
                view.updateStoreExternalData(response.data);
                return view.$helpers.GetExternalServicesMap();
            }).then((services) => {
                if(view.storeSettings.longitude != null && view.storeSettings.latitude != null){
                    view.showMap = true;
                }else{
                    view.showMap = false;
                }
                view.loading = false;
            }).catch(function (error) {
                console.log(error);
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                view.loading = false;
            });

        },
        refreshSotecApiData() {
            let view = this;
            this.loadSotecApiData()
                .then(response => {
                    view.updateSotecApiData(response.data);
                }).catch(function (error) {
                console.log(error);
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
            });
        },
        fileSelected(event){
            this.excelPayloadFile = event.target.files[0];
        },
        OpenDisplayMenuDetails($event){
            let view = this;

            this.$helpers.OpenPopup({
                type: 'burgermenu',
                componentState: this.burgermenuState,
                listStyle: true,
                noScroll: true,
                pointerDirection: 0,
                elRelative: $event.currentTarget,
                pointerOffset: -15,
            });
        },
        openEditSharepointSettingsModal: function(editing){
            this.editingSharepointSettings = editing;
            this.sharepointSettings = this.sharepointConfig != null? this.sharepointConfig : {};
            this.modalImportSharepoint = true;
        },
        OpenEditSotecWebcockpitSettingsPopup(create){
            let view = this;

            let planningIndicatorItems = Object.values(this.planningIndicatorTypeMap).map(p => {return {label: p.name, value: p.id}});
            let selectedTransactionItem = null;
            let selectedIncomeItem = null;
            let selectedNetIncomeItem = null;
            let selectedRtopItem = null;
            let selectedOepeItem = null;
            let selectedProductSalesItem = null;
            let selectedAvgItemCountItem = null;
            let selectedItemCountItem = null;
            if(this.sotecWebcockpitConfig){
                selectedTransactionItem = planningIndicatorItems.find(p => p.value == this.sotecWebcockpitConfig.mdTransactionId);
                selectedIncomeItem = planningIndicatorItems.find(p => p.value == this.sotecWebcockpitConfig.mdIncomeId);
                selectedNetIncomeItem = planningIndicatorItems.find(p => p.value == this.sotecWebcockpitConfig.mdNetIncomeId);
                selectedRtopItem = planningIndicatorItems.find(p => p.value == this.sotecWebcockpitConfig.mdRtopId);
                selectedOepeItem = planningIndicatorItems.find(p => p.value == this.sotecWebcockpitConfig.mdOepeId);
                selectedProductSalesItem = planningIndicatorItems.find(p => p.value == this.sotecWebcockpitConfig.mdProductSalesId);
                selectedAvgItemCountItem = planningIndicatorItems.find(p => p.value == this.sotecWebcockpitConfig.mdAvgItemCountId);
                selectedItemCountItem = planningIndicatorItems.find(p => p.value == this.sotecWebcockpitConfig.mdItemCountId);
            }
            let dataEntries = [
                {label: 'Sotec StoreId', key: 'intStoreId', hidden: false, disabled: false, type: 'numeric', value: this.sotecWebcockpitConfig ? this.sotecWebcockpitConfig.intStoreId : null},
                {label: 'API Key', key: 'apiKey', hidden: false, disabled: false, type: 'text', value: this.sotecWebcockpitConfig ? this.sotecWebcockpitConfig.apiKey : null},
                {label: this.$t('store.settings.tac'), key: 'mdTransactionId', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false,
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: planningIndicatorItems,
                        selectMultiple: false,
                        selectedItems: selectedTransactionItem ? [selectedTransactionItem] : [],
                        selectedItem: selectedTransactionItem ? selectedTransactionItem : {},
                        onceSelected: function ($event, item, searchbar){

                        },
                        styleLight: true,
                        placeholder: '',
                    }},
                {label: this.$t('store.settings.itemsOrderKeyFigure'), key: 'mdAvgItemCountId', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false,
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: planningIndicatorItems,
                        selectMultiple: false,
                        selectedItems: selectedAvgItemCountItem ? [selectedAvgItemCountItem] : [],
                        selectedItem: selectedAvgItemCountItem ? selectedAvgItemCountItem : {},
                        onceSelected: function ($event, item, searchbar){

                        },
                        styleLight: true,
                        placeholder: '',
                    }},
                {label: this.$t('store.settings.itemsKeyFigure'), key: 'mdItemCountId', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false,
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: planningIndicatorItems,
                        selectMultiple: false,
                        selectedItems: selectedItemCountItem ? [selectedItemCountItem] : [],
                        selectedItem: selectedItemCountItem ? selectedItemCountItem : {},
                        onceSelected: function ($event, item, searchbar){

                        },
                        styleLight: true,
                        placeholder: '',
                    }},
                {label: this.$t('store.settings.salesKeyFigure'), key: 'mdIncomeId', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false,
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: planningIndicatorItems,
                        selectMultiple: false,
                        selectedItems: selectedIncomeItem ? [selectedIncomeItem] : [],
                        selectedItem: selectedIncomeItem ? selectedIncomeItem : {},
                        onceSelected: function ($event, item, searchbar){

                        },
                        styleLight: true,
                        placeholder: '',
                    }},
                {label: this.$t('store.settings.productSalesOnly'), key: 'useProductIncome', hidden: false, disabled: false, type: 'bool', value: this.sotecWebcockpitConfig ? (this.sotecWebcockpitConfig.useProductIncome ?  this.sotecWebcockpitConfig.useProductIncome : false ): false},

                {label: this.$t('store.settings.netSalesKeyFigure'), key: 'mdNetIncomeId', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false,
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: planningIndicatorItems,
                        selectMultiple: false,
                        selectedItems: selectedNetIncomeItem ? [selectedNetIncomeItem] : [],
                        selectedItem: selectedNetIncomeItem ? selectedNetIncomeItem : {},
                        onceSelected: function ($event, item, searchbar){

                        },
                        styleLight: true,
                        placeholder: '',
                    }},
                {label: this.$t('store.settings.netProductOnly'), key: 'useNetProductIncome', hidden: false, disabled: false, type: 'bool', value: this.sotecWebcockpitConfig ? (this.sotecWebcockpitConfig.useNetProductIncome ?  this.sotecWebcockpitConfig.useNetProductIncome : false ): false},

                {label: this.$t('store.settings.r2pFigure'), key: 'mdRtopId', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false,
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: planningIndicatorItems,
                        selectMultiple: false,
                        selectedItems: selectedRtopItem ? [selectedRtopItem] : [],
                        selectedItem: selectedRtopItem ? selectedRtopItem : {},
                        onceSelected: function ($event, item, searchbar){

                        },
                        styleLight: true,
                        placeholder: '',
                    }},
                {label: this.$t('store.settings.oepeFigure'), key: 'mdOepeId', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false,
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: planningIndicatorItems,
                        selectMultiple: false,
                        selectedItems: selectedOepeItem ? [selectedOepeItem] : [],
                        selectedItem: selectedOepeItem ? selectedOepeItem : {},
                        onceSelected: function ($event, item, searchbar){

                        },
                        styleLight: true,
                        placeholder: '',
                    }},

                {label: this.$t('store.settings.allowDataAccess'), key: 'allowRead', hidden: false, disabled: false, type: 'bool', value: this.sotecWebcockpitConfig ? (this.sotecWebcockpitConfig.allowRead ): false},
                {label: this.$t('store.settings.planData'), key: 'plannedSalesData', hidden: false, disabled: false, type: 'bool', value: this.sotecWebcockpitConfig ? (this.sotecWebcockpitConfig.plannedSalesData ?  this.sotecWebcockpitConfig.plannedSalesData : false ): false},
                {label: this.$t('store.settings.sotecForecast'), key: 'usePrediction', hidden: !this.isSuperUser, disabled: !this.isSuperUser, type: 'bool', value: this.sotecWebcockpitConfig ? (this.sotecWebcockpitConfig.usePrediction ): false,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let planFlag = datafill.entries.find(i => i.key == 'plannedSalesData').value;

                        if(!planFlag){
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;
                        }  else {
                            entryBeforeUpdate.hidden = !view.isSuperUser
                        }

                        return entryBeforeUpdate;
                    }
                },
                {label: this.$t('store.settings.deactivated'), key: 'disabled', hidden: !this.isSuperUser, disabled: !this.isSuperUser, type: 'bool', value: this.sotecWebcockpitConfig ? (this.sotecWebcockpitConfig.disabled ?  this.sotecWebcockpitConfig.disabled : false ): false},
            ];


            this.$helpers.OpenPopup({
                elRelative: null,
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    selectCallback: function (item) {
                        console.log(item);
                        let config = {
                            intStoreId: item.intStoreId,
                            apiKey: item.apiKey,
                            mdTransactionId:  item.mdTransactionId,
                            mdIncomeId: item.mdIncomeId,
                            mdNetIncomeId: item.mdNetIncomeId,
                            mdRtopId: item.mdRtopId,
                            mdOepeId: item.mdOepeId,
                            plannedSalesData: item.plannedSalesData,
                            disabled: item.disabled,
                            allowRead: item.allowRead,
                            usePrediction: item.usePrediction,
                            useNetProductIncome: item.useNetProductIncome,
                            useProductIncome: item.useProductIncome,
                            mdAvgItemCountId: item.mdAvgItemCountId,
                            mdItemCountId: item.mdItemCountId
                        }
                        if(create){
                            view.createSotecWebcockpitSettings(config);
                        } else {
                            view.updateSotecWebcockpitSettings(config);
                        }
                    },
                },
                header: this.$t('store.settings.sotecWebcockpitData'),
                remainAfterSelect: false,
                expanded: true,
                width: '700px',
                centered: true
            });
        },
        editSharepointSettings: function(evt){
            console.log(this.sharepointSettings);
            evt.preventDefault();
            if(this.editingSharepointSettings){
                this.updateSharepointSettings();
            }else{
                this.createSharepointSettings();
            }
        },

        testSharepointConnection(){
            let view = this;
            let url = '/api/sec/employeefile/sharepoint/token';

            url = this.$helpers.appendParam("externalServiceId", this.sharepointServiceId, url, '/api/sec/employeefile/sharepoint/token');
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeefile/sharepoint/token');

            this.axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url
            }).then((response) => {
                console.log(response);
                if(response.data.type == "SUCCESS"){
                    view.sharepointConnectionTestResult(true);
                }else{
                    view.sharepointConnectionTestResult(false);
                }
            }).catch(function (error){
                view.sharepointConnectionTestResult(false);
            });
        },
        sharepointConnectionTestResult(success){
            let desc = success? this.$t('store.settings.sharepointConnected') : this.$t('store.settings.sharepointError');
            let view = this;
            window.app.popupalerts.push({header: success? this.$t('store.settings.connectionSuccessful') : this.$t('store.settings.connectionError'), number: null, description: desc, hidden: false, callbackAccept: function(popup){
                    popup.hidden = true;
                }, disableCancel: true
            });
        },
        createSharepointSettings(){
            let view = this;
            let url = '/api/sec/storeexternaldata';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/storeexternaldata');

            let payload = {
                externalServiceId: this.sharepointServiceId,
                username: this.sharepointSettings.username,
                password: this.sharepointSettings.password,
                data: {
                    "map": {
                        "tenant_id": this.sharepointSettings.data.map.tenant_id,
                        "client_id": this.sharepointSettings.data.map.client_id,
                        "client_secret": this.sharepointSettings.data.map.client_secret,
                        "driveId": this.sharepointSettings.data.map.driveId,
                        "rootFolderId": this.sharepointSettings.data.map.rootFolderId
                    }
                }
            };
            console.log(payload);
            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('store.settings.sharepointConfigSaved'));
                this.modalImportSharepoint = false;


            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('store.settings.sharepointConfigSaveError'))
                console.log(error)
            })
        },
        updateSharepointSettings(){
            let view = this;
            let url = '/api/sec/storeexternaldata';
            //url = this.$helpers.appendParam("id", this.sharepointConfig.id, url, '/api/sec/storeexternaldata');
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/storeexternaldata');

            let payload = {
                id: this.sharepointConfig.id,
                updateFields: ["externalServiceId", "username", "password", "data"],
                externalServiceId: this.sharepointServiceId,
                username: this.sharepointSettings.username,
                password: this.sharepointSettings.password,
                data: {
                    "map": {
                        "tenant_id": this.sharepointSettings.data.map.tenant_id,
                        "client_id": this.sharepointSettings.data.map.client_id,
                        "client_secret": this.sharepointSettings.data.map.client_secret,
                        "driveId": this.sharepointSettings.data.map.driveId,
                        "rootFolderId": this.sharepointSettings.data.map.rootFolderId
                    }
                }
            };


            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('store.settings.sharepointConfigSaved'));
                this.modalImportSharepoint = false;


            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('store.settings.sharepointConfigSaveError'))
                console.log(error)
            });
        },
        createSotecWebcockpitSettings(config){
            let view = this;
            let url = '/api/sec/sotecapidata';
            let params = {
                storeId: this.$store.state.storeId
            }

            let countryCodeMap = {
                1: "AT",
                2: "DE",
                8: "DE"
            }

            let payload = {
                apiKey: config.apiKey,
                intStoreId: config.intStoreId,
                timeZone: this.storeSettings.timeZone,
                countryCode: countryCodeMap[this.storeSettings.country] ? countryCodeMap[this.storeSettings.country] : "AT",
                mdIncomeId: config.mdIncomeId,
                mdNetIncomeId: config.mdNetIncomeId,
                mdTransactionId: config.mdTransactionId,
                mdRtopId: config.mdRtopId,
                mdOepeId: config.mdOepeId,
                mdItemCountId: config.mdItemCountId,
                plannedSalesData: config.plannedSalesData ? config.plannedSalesData : false,
                disabled: config.disabled ? config.disabled : false,
                allowRead: config.allowRead ? config.allowRead : false,
                usePrediction: config.usePrediction ? config.usePrediction : false,
                useNetProductIncome: config.useNetProductIncome ? config.useNetProductIncome : false,
                useProductIncome: config.useProductIncome ? config.useProductIncome : false,
                storeId: this.storeId,
            };

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload,
                params: params
            }).then(response => {
                view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('store.settings.sotecWebCockpitSaved'));
                view.refreshSotecApiData();

            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('store.settings.sotecWebcockpitSaveError'))
                console.log(error)
            })
        },
        updateSotecWebcockpitSettings(config){
            let view = this;
            let url = '/api/sec/sotecapidata';
            let params = {
                storeId: this.$store.state.storeId
            }
            let countryCodeMap = {
                1: "AT",
                2: "DE",
                8: "DE"
            }

            let payload = {
                id: this.sotecWebcockpitConfig.id,
                updateFields: ["apiKey", "intStoreId", "timeZone", "countryCode", "mdIncomeId", "mdNetIncomeId","mdTransactionId",
                    "mdRtopId", "mdOepeId", "plannedSalesData", "disabled", "allowRead",
                    "usePrediction", "useProductIncome", "useNetProductIncome", "mdItemCountId"],
                apiKey: config.apiKey,
                intStoreId: config.intStoreId,
                timeZone: this.storeSettings.timeZone,
                countryCode: countryCodeMap[this.storeSettings.country] ? countryCodeMap[this.storeSettings.country] : "AT",
                mdIncomeId: config.mdIncomeId,
                mdNetIncomeId: config.mdNetIncomeId,
                mdTransactionId: config.mdTransactionId,
                mdRtopId: config.mdRtopId,
                mdOepeId: config.mdOepeId,
                mdItemCountId: config.mdItemCountId,
                plannedSalesData: config.plannedSalesData ? config.plannedSalesData : false,
                disabled: config.disabled ? config.disabled : false,
                allowRead: config.allowRead ? config.allowRead : false,
                usePrediction: config.usePrediction ? config.usePrediction : false,
                useNetProductIncome: config.useNetProductIncome ? config.useNetProductIncome : false,
                useProductIncome: config.useProductIncome ? config.useProductIncome : false,
                storeId: this.storeId,
            };



        this.axios({
            method: 'put',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            params: params,
            data: payload
        }).then(response => {
            view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('store.settings.sotecWebCockpitSaved'));
            view.refreshSotecApiData();


        }).catch(function (error) {
             view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('store.settings.sotecSaveError'))
            console.log(error)
        });
    },
    OpenResetUsageStartDatePopup($event){
        let description = this.$t('store.settings.operationStartHelp')
        let view = this;
        let date = this.$helpers.getMomentUTC().startOf('month');


        let dataEntries = [

        {label: this.$t('store.settings.startDate'), key: 'usageStartDate', hidden: false, type: 'date', value: date},
                {label: this.$t('store.settings.monthClosingsDelete'), key: 'deleteEmployeeWorkBalances', hidden: false, type: 'bool', value: false},
                {label: this.$t('store.settings.absencesDelete'), key: 'deleteEmployeePreferences', hidden: false, type: 'bool', value: false},
                {label: this.$t('store.settings.planShiftsDelete'), key: 'deletePlanShifts', hidden: false, type: 'bool', value: false},
                {label: this.$t('store.settings.punchedTimesDelete'), key: 'deleteActualShifts', hidden: false, type: 'bool', value: false},
                {label: this.$t('store.settings.rostersDelete'), key: 'deleteShiftTemplates', hidden: false, type: 'bool', value: false},
                {label: this.$t('global.ui.confirm'), key: 'confirmField', hidden: false, type: 'text', value: null},
        ];
        let target = $event.currentTarget;

        this.$helpers.OpenPopup({
            elRelative: target,
            type: 'datafill',
            componentState: {
                entries: dataEntries,
                errorCheck: [
                    (entries) => {
                        if(view.storeSettings.name != entries.confirmField){
                            return {key: 'confirmField', type: 'error', label: this.$t('global.ui.confirm'), text: this.$t('store.settings.storeNameConfirmation')}
                        } else {
                            return null
                        }
                    },

                ],
                description: description,
                selectCallback: function (storeSetting) {
                    view.resetUsageStartDateAndStoreData(storeSetting);
                }
            },
            header: this.$t('store.settings.editStartDate'),
            centered: true,
            expanded: true,
        });
    },
    refreshStoreLocation(){
        let view = this;
        let url = '/api/sec/storesettings/refreshlocation';

        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/storesettings/refreshlocation');
        this.loading = true;
        this.axios({
            method: 'get',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
        }).then(response => {
            //console.log(response);
            view.$helpers.success(view.$t('global.notifications.updateSuccessful'), view.$t('store.settings.addressLocationUpdated'));
            view.loading = false;
            view.refresh(true);
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('store.settings.addressUpdateError'));
            view.loading = false;
            console.log(error)
        });
    },
    OpenEditPopup($event, storeSetting){
        let view = this;

        let selectedTimeZoneItems = [];
        this.timeZoneList.forEach(e => {
            if(e.value == storeSetting.timeZone){
                selectedTimeZoneItems.push(e);
            }
        });
        let selectedCountryItems = []
        this.countryList.forEach(e => {
            if(e.value == storeSetting.country){
                selectedCountryItems.push(e);
            }
        });

            let selectedFederalStateItems = [];
            this.federalStateList.forEach(e => {
                if(e.value == storeSetting.federalState){
                    selectedFederalStateItems.push(e);
                }
            });


            let selectedWorkTimeModes = [];
            this.workTimeModes.forEach(e => {
                if(e.value == storeSetting.workTimeMode){
                    selectedWorkTimeModes.push(e);
                }
            });

            let selectedWorkDayCalcModes = [];
            this.workDayCalcModes.forEach(e => {
                if(e.value == storeSetting.workDayCalcMode){
                    selectedWorkDayCalcModes.push(e);
                }
            });

            let selectedVacationFactoring = [];
            this.vacationFactoringModes.forEach(e => {
                if(e.value == storeSetting.vacationFactoring){
                    selectedVacationFactoring.push(e);
                }
            })
            let selectedExitFactoring = [];
            this.exitFactoringModes.forEach(e => {
                if(e.value == storeSetting.exitFactoring){
                    selectedExitFactoring.push(e);
                }
            })
            let marketTypeItems = Object.values(this.marketTypeMap);
            let selectedMarketType = marketTypeItems.find(l => l.value == storeSetting.marketType);
            let employeeLevelItems = Object.values(this.employeeLevelMap);
            let selectedLevel = employeeLevelItems.find(l => l.value == storeSetting.maxEmployeeLevelToMp);

            let deadlineTypeItems = [{label: this.$t('store.settings.deadlineType1'), value: 1}, {label: this.$t('store.settings.deadlineType2'), value: 2}];
            let selectedDeadlineType = deadlineTypeItems.find(l => l.value == storeSetting.appEmployeePreferencesDeadlineType);

            let deadlineItems = [];
            for(var i = 1; i <= 31; i++){
                deadlineItems.push({
                    label: i + ". " + this.$t('store.settings.ofCurrentMonth'),
                    value: i
                });
            }
            let selectedDeadline = deadlineItems.find(l => l.value == storeSetting.appEmployeePreferencesDeadline);
            if(!selectedDeadline){
                selectedDeadline = deadlineItems[0];
            }

            let approvableTypeItems = [];
            Object.values(this.uiDataMap.employeeAvailabilityTypes).forEach(type =>{
                if(type.id != 5){
                    let option = {label: type.label_de, value: type.id, type: type, selected: storeSetting.empApprovablePrefTypes.includes(type.id)};
                    approvableTypeItems.push(option);
                }

            });
            let selectedApprovableTypeItems = approvableTypeItems.filter(item => storeSetting.empApprovablePrefTypes.includes(item.value))

            let allowedTypeItems = [];
            Object.values(this.uiDataMap.employeeAvailabilityTypes).forEach(type =>{
                if(type.id != 5 && type.id != 1){
                    let option = {label: type.label_de, value: type.id, type: type, selected: storeSetting.allowedAppPreferenceTypes.includes(type.id)};
                    allowedTypeItems.push(option);
                }

            });
            let selectedAllowedTypeItems = allowedTypeItems.filter(item => storeSetting.allowedAppPreferenceTypes.includes(item.value))

            let allowedSubtypeItems = [];
            Object.values(this.uiDataMap.employeeAvailabilitySubtypes).forEach(subtype =>{
                if(subtype.parentType != 5 && subtype.parentType != 1){
                    let parentLabel = this.uiDataMap.employeeAvailabilityTypes.find(i => i.id == subtype.parentType).label_de;
                    let option = {label: parentLabel+' - '+subtype.label_de, subtype: subtype, value: subtype.id, selected: storeSetting.allowedAppPreferenceSubtypes.includes(subtype.id)};
                    allowedSubtypeItems.push(option);
                }

            });
            allowedSubtypeItems.sort((a, b) => a.label.localeCompare(b.label));
            let selectedAllowedSubtypeItems = allowedTypeItems.filter(item => storeSetting.allowedAppPreferenceSubtypes.includes(item.value))

            let lawCheckSpareTimeTypeItems = [];
            Object.values(this.uiDataMap.employeeAvailabilityTypes).forEach(type =>{
                if(type.id != 5){
                    let option = {label: type.label_de, value: type.id, type: type, selected: storeSetting.lawCheckSpareTimePrefTypes.includes(type.id)};
                    lawCheckSpareTimeTypeItems.push(option);
                }

            });
            let selectedLawCheckSpareTimeTypeItems = lawCheckSpareTimeTypeItems.filter(item => storeSetting.lawCheckSpareTimePrefTypes.includes(item.value))

            let lawCheckRestTimeTypeItems = [];
            Object.values(this.uiDataMap.employeeAvailabilityTypes).forEach(type =>{
                if(type.id != 5){
                    let option = {label: type.label_de, value: type.id, type: type, selected: storeSetting.lawCheckRestTimePrefTypes.includes(type.id)};
                    lawCheckRestTimeTypeItems.push(option);
                }

            });
            let selectedLawCheckRestTimeTypeItems = lawCheckRestTimeTypeItems.filter(item => storeSetting.lawCheckRestTimePrefTypes.includes(item.value))

            let youthWorkConfigItems = Object.values(view.youthWorkConfigMap)
                .filter(ywc => ywc.country == storeSetting.country)
                .map(ywc => { return {label: ywc.name, value: ywc.id, selected: storeSetting.defaultYouthWorkConfig == ywc.id}});

            let selectedYouthWorkConfig = youthWorkConfigItems.find(i => i.selected);

            let dataEntries = [
                {label: 'Id', key: 'id', hidden: true, type: '', value: storeSetting.id},
                {label: this.$t('pages.employeeData.name'), key: 'name', hidden: false, type: 'text', value: storeSetting.name},
                {label: this.$t('store.events.description'), key: 'description', hidden: false, type: 'text', value: storeSetting.description},
                {label: this.$t('store.settings.timezone'), key: 'timeZone', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false, dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: this.timeZoneList,
                        selectMultiple: false,
                        selectedItems: selectedTimeZoneItems,
                        selectedItem: selectedTimeZoneItems.length > 0 ? selectedTimeZoneItems[0] : null,
                        onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                        placeholder: this.$t('store.settings.selectTimezone'),
                    }
                },
                {divider: true},
                {label: this.$t('pages.employeeCoreData.address'), key: 'address', hidden: false, type: 'text', disabled: true, value: storeSetting.address},
                {label: this.$t('pages.employeeCoreData.city'), key: 'city', hidden: false, type: 'text', disabled: true, value: storeSetting.city},
                {label: this.$t('pages.employeeCoreData.postalCode'), key: 'postalCode', hidden: false, type: 'text', disabled: true, value: storeSetting.postalCode},
                {label: this.$t('pages.employeeCoreData.country'), key: 'country', hidden: !this.isSuperUser, type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false, dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: this.countryList,
                        selectMultiple: false,
                        selectedItems: selectedCountryItems,
                        selectedItem: selectedCountryItems.length > 0 ? selectedCountryItems[0] : null,
                        onceSelected: function ($event, item, searchbar){


                        },
                        styleLight: true,
                        placeholder: this.$t('store.settings.selectCountry'),
                    }
                },
                {label: this.$t('store.settings.federalState'), key: 'federalState', hidden: !this.isSuperUser, type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false,
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: this.federalStateList.filter(s => s.country == storeSetting.country),
                        selectMultiple: false,
                        selectedItems: selectedFederalStateItems,
                        selectedItem: selectedFederalStateItems.length > 0 ? selectedFederalStateItems[0] : null,
                        onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                        placeholder: this.$t('store.settings.selectFederalState'),
                    },computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let country = datafill.entries.find(i => i.key == 'country').value;


                        if(country){
                            let federalStateItems = view.federalStateList.filter(s => s.country == country);
                            let selectedFederalStateItems = [];
                            federalStateItems.forEach(fs => {
                                if(entryBeforeUpdate.value == fs.value){
                                    selectedFederalStateItems.push(fs);
                                }
                            });
                            let selectedItem = selectedFederalStateItems.length > 0 ? selectedFederalStateItems[0] : null;

                            let entry =  {label: this.$t('store.settings.federalState'),
                                key: 'federalState',
                                hidden: !view.isSuperUser,
                                type: 'dropdownsearch',
                                value: selectedItem != null ? selectedItem.value : null,
                                selectMultiple: false,
                                flexGroup: false,
                                dropdownSearchState:{
                                    toggled: false,
                                    displayedItems: [],
                                    input: '',
                                    items: federalStateItems,
                                    selectMultiple: false,
                                    selectedItems: selectedFederalStateItems,
                                    selectedItem: selectedItem,
                                    onceSelected: function ($event, item, searchbar){
                                    },
                                    styleLight: true,
                                    placeholder: this.$t('store.settings.selectFederalState'),
                                }};


                            return entry;

                        }
                        return entryBeforeUpdate;
                    }
                },
                {label: this.$t('store.settings.market') + ': ', key: 'marketType', hidden: !view.isSuperUser, type: 'dropdownsearch', value: storeSetting.marketType, selectMultiple: false, flexGroup: false, dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: marketTypeItems,
                        selectMultiple: false,
                        selectedItems: [selectedMarketType],
                        selectedItem: selectedMarketType,
                        onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                        placeholder: this.$t('store.settings.selectMarket'),
                    }},
                {label: this.$t('store.settings.minMarketSize'), key: 'marketSizeLimit', hidden: !this.isSuperUser, type: 'slider',
                    value: (storeSetting.marketSizeLimit < 0 ? 0 : storeSetting.marketSizeLimit),
                    min: 0, max: 100, slider: {min: 0, max: 100, value: (storeSetting.marketSizeLimit < 0 ? 0 : storeSetting.marketSizeLimit),
                        step: 1, inputControl: true, sliderInput: (x) => {return x}}},

                {label: this.$t('store.settings.youthWork') + ': ', key: 'defaultYouthWorkConfig', hidden: false, type: 'dropdownsearch', value: storeSetting.defaultYouthWorkConfig, selectMultiple: false, flexGroup: false, dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: youthWorkConfigItems,
                        selectMultiple: false,
                        selectedItems: [selectedYouthWorkConfig],
                        selectedItem: selectedYouthWorkConfig,
                        onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                        placeholder: this.$t('store.settings.selectSettings'),
                    }},
                {divider: true},
                //App Settings
                {label: this.$t('store.settings.contactNotifications'), key: 'allowContactPersonMessage', hidden: false, type: 'bool', value: storeSetting.allowContactPersonMessage},
                {label: this.$t('store.settings.companyEmail'), key: 'enableCompanyEmail', hidden: false, type: 'bool', value: storeSetting.enableCompanyEmail},
                {label: this.$t('store.settings.wishOnApp'), key: 'allowAppEmployeePreferences', hidden: false, type: 'bool', value: storeSetting.allowAppEmployeePreferences},
                {label: this.$t('store.settings.confirmAppWishes'), key: 'unapproveAppEmployeePreferences', hidden: this.$helpers.CheckDatafillKeysForHidden('allowAppEmployeePreferences'), type: 'bool', value: storeSetting.unapproveAppEmployeePreferences},
                {label: this.$t('store.settings.maxWishesPerMonth'), key: 'maxAppEmployeePreferences', hidden: this.$helpers.CheckDatafillKeysForHidden('allowAppEmployeePreferences'), type: 'slider',
                    value: storeSetting.maxAppEmployeePreferences, min: 1, max: 31, slider: {min: 1, max: 31, value: storeSetting.maxAppEmployeePreferences,
                        step: 1, DisplayLabel: (x) => {return x}, inputControl: true, sliderInput: (x) => {return x}}},
                {label: this.$t('store.settings.wishDeadline'), key: 'enableAppEmployeePreferencesDeadline', hidden: false, type: 'bool', value: storeSetting.enableAppEmployeePreferencesDeadline},
                {label: this.$t('store.settings.wishDeadlineType'), key: 'appEmployeePreferencesDeadlineType', hidden: !storeSetting.enableAppEmployeePreferencesDeadline, type: 'dropdownsearch', value: storeSetting.appEmployeePreferencesDeadlineType, 
                    flexGroup: false, 
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: deadlineTypeItems,
                        selectMultiple: false,
                        selectedItems: [selectedDeadlineType],
                        selectedItem: selectedDeadlineType,
                        onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                        placeholder: this.$t('store.settings.pleaseSelect'),
                    },
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let enableAppEmployeePreferencesDeadline = datafill.entries.find(i => i.key == 'enableAppEmployeePreferencesDeadline').value;


                        if(!enableAppEmployeePreferencesDeadline){
                            entryBeforeUpdate.hidden = true;

                        } else {
                            entryBeforeUpdate.hidden = false;
                        }
                        return entryBeforeUpdate;
                    }
                },
                {label: this.$t('store.settings.wishDeadlineDate'), key: 'appEmployeePreferencesDeadline', hidden: (!storeSetting.enableAppEmployeePreferencesDeadline || storeSetting.appEmployeePreferencesDeadlineType == 2), type: 'dropdownsearch', value: storeSetting.appEmployeePreferencesDeadline, 
                    flexGroup: false, 
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: deadlineItems,
                        selectMultiple: false,
                        selectedItems: [selectedDeadline],
                        selectedItem: selectedDeadline,
                        onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                        placeholder: this.$t('store.settings.pleaseSelect'),
                    },
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let enableAppEmployeePreferencesDeadline = datafill.entries.find(i => i.key == 'enableAppEmployeePreferencesDeadline').value;
                        let deadlineType = datafill.entries.find(i => i.key == 'appEmployeePreferencesDeadlineType').value;

                        if(!enableAppEmployeePreferencesDeadline || deadlineType == 2){
                            entryBeforeUpdate.hidden = true;

                        } else {
                            let selectedDeadline = deadlineItems.find(l => l.value == entryBeforeUpdate.value);
                            if(!selectedDeadline){
                                selectedDeadline = deadlineItems[0];
                                entryBeforeUpdate.value = selectedDeadline.value;
                            }
                            entryBeforeUpdate.hidden = false;
                        }
                        return entryBeforeUpdate;
                    }
                },
                {label: this.$t('store.settings.wishDeadlineDays'), key: 'appEmployeePreferencesDeadline2', hidden: (!storeSetting.enableAppEmployeePreferencesDeadline || storeSetting.appEmployeePreferencesDeadlineType == 1), type: 'slider', value: storeSetting.appEmployeePreferencesDeadline, 
                    flexGroup: false, 
                    slider: {
                        min: 1, max: 366, value: storeSetting.appEmployeePreferencesDeadline, step: 1,
                        inputControl: true, 
                        sliderInput: (x) => {return x},
                        labelToInt: (x) => {return x.slice(0, -1)},
                        DisplayLabel: (val) => {return val},
                    },
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let enableAppEmployeePreferencesDeadline = datafill.entries.find(i => i.key == 'enableAppEmployeePreferencesDeadline').value;
                        let deadlineType = datafill.entries.find(i => i.key == 'appEmployeePreferencesDeadlineType').value;

                        if(!enableAppEmployeePreferencesDeadline || deadlineType == 1){
                            entryBeforeUpdate.hidden = true;

                        } else {
                            entryBeforeUpdate.hidden = false;
                        }
                        return entryBeforeUpdate;
                    }
                },
                {label: this.$t('store.settings.vacateOnApp'), key: 'allowAppVacationRequests', hidden: false, type: 'bool', value: storeSetting.allowAppVacationRequests},
                {label: this.$t('store.settings.enableAppVacReqYearLimit'), key: 'enableAppVacReqYearLimit', hidden: !storeSetting.allowAppVacationRequests, type: 'bool', value: storeSetting.enableAppVacReqYearLimit, 
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let allowAppVacationRequests = datafill.entries.find(i => i.key == 'allowAppVacationRequests').value;
                        if(!allowAppVacationRequests || !view.isSuperUser){
                            entryBeforeUpdate.hidden = true;
                            entryBeforeUpdate.value = false;
                        } else {
                            entryBeforeUpdate.hidden = false;
                        }
                        return entryBeforeUpdate;
                    }
                },
                {label: this.$t('store.settings.dayBeforeVacationRequest'), key: 'appVacationDeadline', hidden: !storeSetting.allowAppVacationRequests, type: 'slider',
                    value: (storeSetting.appVacationDeadline < 0 ? 0 : storeSetting.appVacationDeadline),
                    slider: {min: 0, max: 31, value: (storeSetting.appVacationDeadline < 0 ? 0 : storeSetting.appVacationDeadline), step: 1},
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let allowAppVacationRequests = datafill.entries.find(i => i.key == 'allowAppVacationRequests').value;
                        if(!allowAppVacationRequests){
                            entryBeforeUpdate.hidden = true;
                        } else {
                            entryBeforeUpdate.hidden = false;
                        }
                        return entryBeforeUpdate;
                    }
                },
                {label: this.$t('store.settings.minAppVacReqEmploymentDays'), key: 'minAppVacReqEmploymentDays', hidden: !storeSetting.allowAppVacationRequests, type: 'slider',
                    value: (storeSetting.minAppVacReqEmploymentDays < 0 ? 0 : storeSetting.minAppVacReqEmploymentDays),
                    slider: {min: 0, max: 365, value: (storeSetting.minAppVacReqEmploymentDays < 0 ? 0 : storeSetting.minAppVacReqEmploymentDays), step: 1},
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let allowAppVacationRequests = datafill.entries.find(i => i.key == 'allowAppVacationRequests').value;
                        if(!allowAppVacationRequests || !view.isSuperUser){
                            entryBeforeUpdate.hidden = true;
                        } else {
                            entryBeforeUpdate.hidden = false;
                        }
                        return entryBeforeUpdate;
                    }
                },
                
                
                {label: this.$t('store.settings.shiftDeniesOnApp'), key: 'enableAppShiftStatus', hidden: false, type: 'bool', value: storeSetting.enableAppShiftStatus},
                {label: this.$t('store.settings.documentUploadByEmployees'), key: 'allowFileUploadByEmployee', hidden: false, type: 'bool', value: storeSetting.allowFileUploadByEmployee},
                {label: this.$t('store.settings.absencesByEmployees'), key: 'allowedAppPreferenceTypes', hidden: false, type: 'dropdownsearch', value: storeSetting.allowedAppPreferenceTypes,
                    selectMultiple: true,
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: selectedAllowedTypeItems,
                        input: '',
                        items: allowedTypeItems,
                        selectMultiple: true,
                        selectedItems: selectedAllowedTypeItems,
                        selectFirst: false,
                        styleLight: true,
                    }
                },
                {label: this.$t('store.settings.absenceReasons'), key: 'allowedAppPreferenceSubtypes', hidden: false, type: 'dropdownsearch', value: storeSetting.allowedAppPreferenceSubtypes,
                    selectMultiple: true,
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: selectedAllowedSubtypeItems,
                        input: '',
                        items: allowedSubtypeItems,
                        selectMultiple: true,
                        selectedItems: selectedAllowedSubtypeItems,
                        selectFirst: false,
                        styleLight: true,
                    }
                },
                {label: this.$t('store.settings.employeeConfirmAbsence'), key: 'enableApprovingPreferences', hidden: false, type: 'bool', value: storeSetting.empApprovablePrefTypes.length > 0},
                {label: this.$t('store.settings.confirmAbsencesByEmployees'), key: 'empApprovablePrefTypes', hidden: storeSetting.empApprovablePrefTypes.length == 0, type: 'dropdownsearch', value: storeSetting.empApprovablePrefTypes,
                    selectMultiple: true,
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: selectedApprovableTypeItems,
                        input: '',
                        items: approvableTypeItems,
                        selectMultiple: true,
                        selectedItems: selectedApprovableTypeItems,
                        selectFirst: false,
                        styleLight: true,
                    },computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let enableApprovingPreferences = datafill.entries.find(i => i.key == 'enableApprovingPreferences').value;


                        if(!enableApprovingPreferences){

                            entryBeforeUpdate.value = [];
                            entryBeforeUpdate.dropdownSearchState.selectedItems = [];
                            entryBeforeUpdate.dropdownSearchState.displayedItems = [];
                            entryBeforeUpdate.dropdownSearchState.items.forEach(i => i.selected = false);
                            entryBeforeUpdate.hidden = true;

                        } else {
                            entryBeforeUpdate.hidden = false;
                        }
                        return entryBeforeUpdate;
                    }
                },
                {label: this.$t('store.settings.showBalanceInApp'), key: 'enableAppBalanceDisplay', hidden: false, type: 'bool', value: storeSetting.enableAppBalanceDisplay},
                {label: this.$t('store.settings.showHoursInApp'), key: 'enableAppCalculatedBalanceDisplay', hidden: false, type: 'bool', value: storeSetting.enableAppCalculatedBalanceDisplay},

                {label: this.$t('store.settings.showHolidayHoursInApp'), key: 'enableAppHolidayTimeDisplay', hidden: false, type: 'bool', value: storeSetting.enableAppHolidayTimeDisplay},
                {label: this.$t('store.settings.showOvertimeInApp'), key: 'enableAppOverTimeDisplay', hidden: false, type: 'bool', value: storeSetting.enableAppOverTimeDisplay},

                {label: this.$t('store.settings.seePayInApp'), key: 'enableAppEmployeePaymentDisplay', hidden: false, type: 'bool', value: storeSetting.enableAppEmployeePaymentDisplay},
                {label: this.$t('store.settings.commentOutOfShift'), key: 'requireActualShiftComment', hidden: false, type: 'bool', value: storeSetting.requireActualShiftComment},
                {label: this.$t('store.settings.betaChat'), key: 'enableAppChat', hidden: false, type: 'bool', value: storeSetting.enableAppChat},


                {divider: true},
                {label: this.$t('store.settings.mandatoryWageGroups'), key: 'enforceWageGroup', hidden: false, type: 'bool', value: storeSetting.enforceWageGroup},
                {label: this.$t('store.settings.meo'), key: 'enableMeo', hidden: false, type: 'bool', value: storeSetting.enableMeo},
                {label: this.$t('store.settings.vlh'), key: 'enableVlh', hidden: false, type: 'bool', value: storeSetting.enableVlh},
                {label: this.$t('store.settings.deactivated'), key: 'disabled', hidden: !this.isSuperUser, type: 'bool', value: storeSetting.disabled},
                {label: this.$t('store.settings.rosterPlaning'), key: 'allowFutureAssignment', hidden: !this.isSuperUser, type: 'bool', value: storeSetting.allowFutureAssignment},

                {label: this.$t('store.settings.hideDeactivatedEmps'), key: 'hideDeactivatedEmployees', hidden: false, type: 'bool', value: storeSetting.hideDeactivatedEmployees},

                {label: this.$t('store.settings.nonWeekRest'), key: 'lawCheckSpareTimePrefTypes', hidden: false, type: 'dropdownsearch', value: storeSetting.lawCheckSpareTimePrefTypes,
                    selectMultiple: true,
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: lawCheckSpareTimeTypeItems,
                        input: '',
                        items: lawCheckSpareTimeTypeItems,
                        selectMultiple: true,
                        selectedItems: selectedLawCheckSpareTimeTypeItems,
                        selectFirst: false,
                        styleLight: true,
                    }
                },
                {label: this.$t('store.settings.nonRest'), key: 'lawCheckRestTimePrefTypes', hidden: false, type: 'dropdownsearch', value: storeSetting.lawCheckRestTimePrefTypes,
                    selectMultiple: true,
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: lawCheckRestTimeTypeItems,
                        input: '',
                        items: lawCheckRestTimeTypeItems,
                        selectMultiple: true,
                        selectedItems: selectedLawCheckRestTimeTypeItems,
                        selectFirst: false,
                        styleLight: true,
                    }
                },
                {label: this.$t('store.settings.averageAbsenceWorkingUse'), key: 'useAvgWorkTimeForPrefs', hidden: !this.isSuperUser, type: 'bool', value: storeSetting.useAvgWorkTimeForPrefs},
                {label: this.$t('store.settings.activateAutoLogout'), key: 'enableAutoLogout', hidden: false, type: 'bool', value: storeSetting.autoLogoutTime > 0},
                {label: this.$t('store.settings.autoLogout'), key: 'autoLogoutTime', hidden: this.$helpers.CheckDatafillKeysForHidden('enableAutoLogout'), type: 'slider',
                    value: Math.max(5, storeSetting.autoLogoutTime), min: 5, max: 4*60, slider: {min: 5, max: 4*60, value: Math.max(5, storeSetting.autoLogoutTime), step: 1, DisplayLabel: (x) => {return x}, hideMin: true, hideMax: true}},
                {label: this.$t('store.settings.maxEmployeeLevelToMp'), key: 'maxEmployeeLevelToMp', hidden: false, type: 'dropdownsearch', value: storeSetting.maxEmployeeLevelToMp, selectMultiple: false, flexGroup: false, dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: employeeLevelItems,
                        selectMultiple: false,
                        selectedItems: [selectedLevel],
                        selectedItem: selectedLevel,
                        onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                        placeholder: this.$t('store.structure.selectEmployeeLevel'),
                    }},
                {divider: true},

                {label: this.$t('pages.employeeContract.workDays'), key: 'workDays', hidden: false, type: 'togglelist', toggleEntries: [
                        {label:this.$t('store.openingHours.weekDay1Short'), value: 1, selected: storeSetting.workDays.includes(1)},
                        {label:this.$t('store.openingHours.weekDay2Short'), value: 2, selected: storeSetting.workDays.includes(2)},
                        {label:this.$t('store.openingHours.weekDay3Short'), value: 3, selected: storeSetting.workDays.includes(3)},
                        {label:this.$t('store.openingHours.weekDay4Short'), value: 4, selected: storeSetting.workDays.includes(4)},
                        {label:this.$t('store.openingHours.weekDay5Short'), value: 5, selected: storeSetting.workDays.includes(5)},
                        {label:this.$t('store.openingHours.weekDay6Short'), value: 6, selected: storeSetting.workDays.includes(6)},
                        {label:this.$t('store.openingHours.weekDay7Short'), value: 7, selected: storeSetting.workDays.includes(7)},
                    ]
                },
                {label: (storeSetting.country == 1 ? this.$t('pages.employeeContract.collectiveContract') : this.$t('pages.employeeContract.contractModel')) +" " + this.$t('store.settings.needed'), key: 'collectiveContractRequired', hidden: !this.isSuperUser, type: 'bool', value: storeSetting.collectiveContractRequired},
                {label: (storeSetting.country == 1 ? this.$t('store.settings.nightOperations') : this.$t('store.settings.mandatoryNightShift')), key: 'nightWorkRequired', hidden: false, type: 'bool', value: storeSetting.nightWorkRequired},
                {label: this.$t('store.settings.noBreaks'), key: 'noBreaks', hidden: !this.isSuperUser, type: 'bool', value: storeSetting.noBreaks},

                {label: this.$t('store.settings.breakTime'), key: 'defaultBreakTime', hidden: true, type: 'slider', value: storeSetting.defaultBreakTime, min: 0, max: 240, slider: {min: 0, max: 240, value: storeSetting.defaultBreakTime, step: 1}},
                {label: this.$t('store.settings.workTimeModel'), key: 'workTimeMode', hidden: false, type: 'dropdownsearch', value: storeSetting.workTimeMode, selectMultiple: false, flexGroup: false, dropdownSearchState: {
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: this.workTimeModes,
                        selectMultiple: false,
                        selectedItems: selectedWorkTimeModes,
                        selectedItem: selectedWorkTimeModes.length > 0 ? selectedWorkTimeModes[0] : this.workTimeModes[0],
                        onceSelected: function($event, item, searchbar) {
                        },
                        styleLight: true,
                        placeholder: this.$t('store.settings.selectWorkTimeModel'),
                    }
                },
                {
                    label: this.$t('store.settings.aliquot'),
                    key: 'aliquoteWorkTime',
                    hidden: false,
                    type: 'bool',
                    value: storeSetting.aliquoteWorkTime
                },

                {
                    label: this.$t('store.settings.maxWorkTimePerCalc'),
                    key: 'workDayCalcMode',
                    hidden: false,
                    type: 'dropdownsearch',
                    value: storeSetting.workDayCalcMode,
                    selectMultiple: false,
                    flexGroup: false,
                    dropdownSearchState: {
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: this.workDayCalcModes,
                        selectMultiple: false,
                        selectedItems: selectedWorkDayCalcModes,
                        selectedItem: selectedWorkDayCalcModes.length > 0 ? selectedWorkDayCalcModes[0] : this.workDayCalcModes[0],
                        onceSelected: function($event, item, searchbar) {
                        },
                        styleLight: true,
                        placeholder: this.$t('store.settings.selectWorkTimeModel'),
                    }
                },
                {
                    label: this.$t('store.settings.multiShifting'),
                    key: 'allowMultiShiftAssign',
                    hidden: false,
                    type: 'bool',
                    value: storeSetting.allowMultiShiftAssign
                },
                
                {
                    label: this.$t('store.settings.autoResizeShifts'),
                    key: 'autoResizeShifts',
                    hidden: false,
                    type: 'bool',
                    value: storeSetting.autoResizeShifts
                },
                {
                    label: this.$t('store.settings.overtimeCalcContract'),
                    key: 'enableWorkdayOvertime',
                    hidden: false,
                    type: 'bool',
                    value: storeSetting.enableWorkdayOvertime
                },
                {
                    label: this.$t('store.settings.shiftOvertime'),
                    key: 'allowShiftOvertime',
                    hidden: false,
                    type: 'bool',
                    value: storeSetting.allowShiftOvertime
                },
                {
                    label: this.$t('store.settings.determineShiftOvertimeLimit'),
                    key: 'enableShiftOvertimeOverride',
                    hidden: storeSetting.allowShiftOvertime,
                    type: 'bool',
                    value: storeSetting.shiftOvertimeOverride > 0,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let allowShiftOvertime = datafill.entries.find(i => i.key == 'allowShiftOvertime').value;

                        if (!allowShiftOvertime) {
                            entryBeforeUpdate.hidden = false;

                        } else {
                            entryBeforeUpdate.value = false;

                            entryBeforeUpdate.hidden = true;
                        }
                        return entryBeforeUpdate;
                    }
                },
                {
                    label: this.$t('store.settings.shiftOvertimeLimit'),
                    key: 'shiftOvertimeOverride',
                    hidden: this.$helpers.CheckDatafillKeysForHidden('enableShiftOvertimeOverride'),
                    type: 'slider',
                    value: (storeSetting.shiftOvertimeOverride < 0 ? 8 * 60 : storeSetting.shiftOvertimeOverride),
                    min: 8 * 60,
                    max: 12 * 60,
                    slider: {
                        min: 8 * 60,
                        max: 12 * 60,
                        value: (storeSetting.shiftOvertimeOverride < 0 ? 8 * 60 : storeSetting.shiftOvertimeOverride),
                        step: 15,
                        DisplayLabel: (x) => {
                            return (x / 60.0).toFixed(2)
                        }
                    }
                },

                {
                    label: this.$t('store.settings.weekOvertime'),
                    key: 'allowWeeklyOvertime',
                    hidden: false,
                    type: 'bool',
                    value: storeSetting.allowWeeklyOvertime
                },
                {
                    label: this.$t('store.settings.determineWeekOvertimeLimit'),
                    key: 'enableWeekOvertimeOverride',
                    hidden: storeSetting.allowWeeklyOvertime,
                    type: 'bool',
                    value: storeSetting.weekOvertimeOverride > 0,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let allowShiftOvertime = datafill.entries.find(i => i.key == 'allowWeeklyOvertime').value;

                        if (!allowShiftOvertime) {
                            entryBeforeUpdate.hidden = false;

                        } else {
                            entryBeforeUpdate.value = false;

                            entryBeforeUpdate.hidden = true;
                        }
                        return entryBeforeUpdate;
                    }
                },
                {
                    label: this.$t('store.settings.weekOvertimeLimit'),
                    key: 'weekOvertimeOverride',
                    hidden: this.$helpers.CheckDatafillKeysForHidden('enableWeekOvertimeOverride'),
                    type: 'slider',
                    value: (storeSetting.shiftOvertimeOverride < 0 ? 40 * 60 : storeSetting.weekOvertimeOverride),
                    min: 40 * 60,
                    max: 60 * 60,
                    slider: {
                        min: 40 * 60,
                        max: 60 * 60,
                        value: (storeSetting.weekOvertimeOverride < 0 ? 40 * 60 : storeSetting.weekOvertimeOverride),
                        step: 60,
                        DisplayLabel: (x) => {
                            return (x / 60.0).toFixed(2)
                        }
                    }
                },


                {
                    label: this.$t('store.settings.limitExceedingHours'),
                    key: 'enableRegularWorkTimeLimit',
                    hidden: false,
                    type: 'bool',
                    value: storeSetting.regularWorkTimeLimit > -1
                },
                {
                    label: this.$t('store.settings.limitRealExceedingHours'),
                    key: 'regularWorkTimeLimit',
                    hidden: this.$helpers.CheckDatafillKeysForHidden('enableRegularWorkTimeLimit'),
                    type: 'slider',
                    value: (storeSetting.regularWorkTimeLimit < 0 ? 0 : storeSetting.regularWorkTimeLimit),
                    min: 0,
                    max: 100,
                    slider: {
                        min: 0,
                        max: 100,
                        value: (storeSetting.regularWorkTimeLimit < 0 ? 0 : storeSetting.regularWorkTimeLimit),
                        step: 1,
                        DisplayLabel: (x) => {
                            return x + '%'
                        }
                    }
                },

                {
                    label: this.$t('store.settings.minVacEmploymentDays'),
                    key: 'minVacEmploymentDays',
                    hidden: false,
                    type: 'slider',
                    value: (storeSetting.minVacEmploymentDays),
                    min: 0,
                    max: 30,
                    slider: {
                        min: 0, max: 30, value: storeSetting.minVacEmploymentDays, step: 1, DisplayLabel: (x) => {
                            return x
                        }
                    }
                },
                {
                    label: this.$t('store.settings.vacationAliquotActive'),
                    key: 'aliquoteVac',
                    hidden: false,
                    type: 'bool',
                    value: storeSetting.aliquoteVac
                },
                {
                    label: this.$t('store.settings.holidayAliquot'),
                    key: 'vacationFactoring',
                    hidden: false,
                    type: 'dropdownsearch',
                    value: null,
                    selectMultiple: false,
                    flexGroup: false,
                    dropdownSearchState: {
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: this.vacationFactoringModes,
                        selectMultiple: false,
                        selectedItems: selectedVacationFactoring,
                        selectedItem: selectedVacationFactoring.length > 0 ? selectedVacationFactoring[0] : this.vacationFactoringModes[0],
                        onceSelected: function($event, item, searchbar) {
                        },
                        styleLight: true,
                        placeholder: this.$t('store.settings.holidayAliquot'),
                    }
                },
                {
                    label: this.$t('store.settings.aliquotBasis'),
                    key: 'exitFactoring',
                    hidden: false,
                    type: 'dropdownsearch',
                    value: null,
                    selectMultiple: false,
                    flexGroup: false,
                    dropdownSearchState: {
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: this.exitFactoringModes,
                        selectMultiple: false,
                        selectedItems: selectedExitFactoring,
                        selectedItem: selectedExitFactoring.length > 0 ? selectedExitFactoring[0] : this.exitFactoringModes[0],
                        onceSelected: function($event, item, searchbar) {
                        },
                        styleLight: true,
                        placeholder: this.$t('store.settings.aliquotBasis'),
                    }
                },
                {
                    label: this.$t('store.settings.shiftsOnHolidays'),
                    key: 'shiftsOnHolidays',
                    hidden: false,
                    type: 'bool',
                    value: storeSetting.shiftsOnHolidays
                },
                {
                    label: this.$t('store.settings.useShiftStartForHolidayTime'),
                    key: 'useShiftStartForHolidayTime',
                    hidden: false,
                    type: 'bool',
                    value: storeSetting.useShiftStartForHolidayTime
                },
                { divider: true },
                {
                    label: this.$t('store.settings.separateOvertimeHolidayTime'),
                    key: 'separateOvertimeHolidayTime',
                    hidden: !this.isSuperUser,
                    type: 'bool',
                    value: storeSetting.separateOvertimeHolidayTime
                },
                {
                    label: this.$t('workBalance.accounting.useMultiplier'),
                    key: 'enableWorkBalanceMultiplier',
                    hidden: !this.isSuperUser,
                    type: 'bool',
                    value: storeSetting.enableWorkBalanceMultiplier
                },
                {
                    label: this.$t('workBalance.accounting.useMultiplier'),
                    key: 'workBalanceMultiplier',
                    hidden: this.$helpers.CheckDatafillKeysForHidden('enableWorkBalanceMultiplier'),
                    type: 'slider',
                    value: storeSetting.workBalanceMultiplier,
                    min: 0,
                    max: 300,
                    slider: {
                        min: 0,
                        max: 300,
                        value: storeSetting.workBalanceMultiplier,
                        step: 10,
                        DisplayLabel: (x) => {
                            return (x / 100).toFixed(2)
                        }
                    }
                },
                {
                    label: this.$t('store.settings.workTimeFactor'),
                    key: 'workTimeFactor',
                    hidden: !this.isSuperUser,
                    type: 'slider',
                    value: storeSetting.workTimeFactor,
                    min: 4 * Math.pow(10, 7),
                    max: 4.3333 * Math.pow(10, 7),
                    slider: {
                        min: 4 * Math.pow(10, 7),
                        max: 4.3333 * Math.pow(10, 7),
                        value: storeSetting.workTimeFactor,
                        step: 0.0001 * Math.pow(10, 7),
                        DisplayLabel: (x) => {
                            return (x / Math.pow(10, 7)).toFixed(4)
                        }
                    }
                },
                { divider: true },
                {
                    label: this.$t('store.settings.location'),
                    key: 'location',
                    hidden: false,
                    type: 'location',
                    value: { lat: storeSetting.latitude, lng: storeSetting.longitude },
                    showInitialMarker: (storeSetting.latitude != null && storeSetting.longitude != null),
                    width: 400,
                    height: 250,
                    interactive: true
                },
                //{label: 'Latitude', key: 'latitude', hidden: !this.isSuperUser, type: 'output', value: storeSetting.latitude},
                //{label: 'Longitude', key: 'longitude', hidden: !this.isSuperUser, type: 'output', value: storeSetting.longitude},
            ];

            let target = $event.currentTarget;

            this.$helpers.OpenPopup({
                elRelative: target,
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    selectCallback: function(storeSetting) {
                        if(storeSetting.appEmployeePreferencesDeadlineType == 2){
                            storeSetting.appEmployeePreferencesDeadline = storeSetting.appEmployeePreferencesDeadline2;
                        }
                        view.UpdateStoreSetting(storeSetting);
                    }
                },
                header: this.$t('store.settings.editBasicSettings'),
                centered: true,
                width: '900px',
                expanded: true,
            });
        },
        UpdateStoreSetting: function(storeSetting) {
            console.log('UPDATE STORE SETTINGS:');

            let updateHolidays = false;
            let shiftCreationMode = 0;
            if(this.storeSettings.shiftsOnHolidays != storeSetting.shiftsOnHolidays){
                updateHolidays = true;
                if(storeSetting.shiftsOnHolidays){
                    shiftCreationMode = 0;
                } else {
                    shiftCreationMode = 2;
                }
            }

            let view = this;
            let url = '/api/sec/storesettings';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/storesettings');
            if (!storeSetting.enableWorkBalanceMultiplier) {
                storeSetting.workBalanceMultiplier = 100;
            }
            if (!storeSetting.enableAutoLogout) {
                storeSetting.autoLogoutTime = 0;
            }
            if (!storeSetting.enableApprovingPreferences) {
                storeSetting.empApprovablePrefTypes = [];
            }
            if (!storeSetting.enableRegularWorkTimeLimit) {
                storeSetting.regularWorkTimeLimit = -1;
            }
            if (!storeSetting.enableShiftOvertimeOverride) {
                storeSetting.shiftOvertimeOverride = -1;
            }
            if (!storeSetting.enableWeekOvertimeOverride) {
                storeSetting.weekOvertimeOverride = -1;
            }
            if (storeSetting.workTimeMode != 1) {
                storeSetting.ignoreWorkTimeRegularForHolidays = false;
            }
            let payload = {
                id: storeSetting.id,
                updateFields: ["latitude", "longitude", "collectiveContractRequired", "timeZone", "defaultBreakTime",
                    "workTimeMode", "workTimeFactor", "name", "description", "city", "address", "postalCode", "workDays",
                    "enableWorkBalanceMultiplier", "workBalanceMultiplier", "allowAppEmployeePreferences", "unapproveAppEmployeePreferences",
                    "allowAppVacationRequests", "maxEmployeeLevelToMp", "vacationFactoring", "appEmployeePreferencesDeadline",
                    "employeeDocumentExpiryDays", "enableAppEmployeePreferencesDeadline", "allowContactPersonMessage",
                    "country", "exitFactoring", "allowMultiShiftAssign", "marketType", "allowFutureAssignment",
                    "lawCheckSpareTimePrefTypes", "lawCheckRestTimePrefTypes", "separateOvertimeHolidayTime", "maxAppEmployeePreferences", "autoLogoutTime",
                    "empApprovablePrefTypes", "disabled", "defaultYouthWorkConfig", "enableAppBalanceDisplay",
                    "enableAppEmployeePaymentDisplay", "enableAppHolidayTimeDisplay", "enableAppOverTimeDisplay",
                    "workDayCalcMode", "regularWorkTimeLimit", "marketSizeLimit", "hideDeactivatedEmployees",
                    "nightWorkRequired", "allowShiftOvertime", "allowWeeklyOvertime", "shiftOvertimeOverride",
                    "weekOvertimeOverride", "enableAppShiftStatus", "enableCompanyEmail", "enableWorkdayOvertime",
                    "allowFileUploadByEmployee", "enableMeo", "enableVlh", "useAvgWorkTimeForPrefs", "noBreaks",
                    "appVacationDeadline", "enableAppCalculatedBalanceDisplay", "allowedAppPreferenceTypes",
                    "allowedAppPreferenceSubtypes", "minVacEmploymentDays", "aliquoteVac", "enforceWageGroup",
                    "aliquoteWorkTime", "federalState", "requireActualShiftComment", "enableAppChat", "shiftsOnHolidays", "autoResizeShifts",
                    "appEmployeePreferencesDeadlineType", "enableAppVacReqYearLimit", "minAppVacReqEmploymentDays", "useShiftStartForHolidayTime"],
                name: storeSetting.name,
                description: storeSetting.description,
                latitude: storeSetting.location.lat,
                longitude: storeSetting.location.lng,
                collectiveContractRequired: storeSetting.collectiveContractRequired,
                defaultBreakTime: storeSetting.defaultBreakTime,
                timeZone: storeSetting.timeZone,
                workTimeMode: storeSetting.workTimeMode,
                workTimeFactor: storeSetting.workTimeFactor,
                city: storeSetting.city,
                address: storeSetting.address,
                postalCode: storeSetting.postalCode,
                country: storeSetting.country,
                workDays: storeSetting.workDays,
                enableWorkBalanceMultiplier: storeSetting.enableWorkBalanceMultiplier,
                workBalanceMultiplier: storeSetting.workBalanceMultiplier,
                allowAppEmployeePreferences: storeSetting.allowAppEmployeePreferences,
                unapproveAppEmployeePreferences: storeSetting.unapproveAppEmployeePreferences,
                allowAppVacationRequests: storeSetting.allowAppVacationRequests,
                allowContactPersonMessage: storeSetting.allowContactPersonMessage,
                maxEmployeeLevelToMp: storeSetting.maxEmployeeLevelToMp,
                vacationFactoring: storeSetting.vacationFactoring,
                exitFactoring: storeSetting.exitFactoring,
                appEmployeePreferencesDeadline: storeSetting.appEmployeePreferencesDeadline,
                enableAppEmployeePreferencesDeadline: storeSetting.enableAppEmployeePreferencesDeadline,
                employeeDocumentExpiryDays: storeSetting.employeeDocumentExpiryDays,
                allowMultiShiftAssign: storeSetting.allowMultiShiftAssign,
                marketType: storeSetting.marketType,
                allowFutureAssignment: storeSetting.allowFutureAssignment,
                lawCheckSpareTimePrefTypes: storeSetting.lawCheckSpareTimePrefTypes,
                lawCheckRestTimePrefTypes: storeSetting.lawCheckRestTimePrefTypes,
                separateOvertimeHolidayTime: storeSetting.separateOvertimeHolidayTime,
                maxAppEmployeePreferences: storeSetting.maxAppEmployeePreferences,
                autoLogoutTime: storeSetting.autoLogoutTime,
                empApprovablePrefTypes: storeSetting.empApprovablePrefTypes,
                disabled: storeSetting.disabled,
                defaultYouthWorkConfig: storeSetting.defaultYouthWorkConfig,
                enableAppBalanceDisplay: storeSetting.enableAppBalanceDisplay,
                enableAppEmployeePaymentDisplay: storeSetting.enableAppEmployeePaymentDisplay,
                enableAppHolidayTimeDisplay: storeSetting.enableAppHolidayTimeDisplay,
                enableAppOverTimeDisplay: storeSetting.enableAppOverTimeDisplay,
                workDayCalcMode: storeSetting.workDayCalcMode,
                regularWorkTimeLimit: storeSetting.regularWorkTimeLimit,
                marketSizeLimit: storeSetting.marketSizeLimit,
                hideDeactivatedEmployees: storeSetting.hideDeactivatedEmployees,
                nightWorkRequired: storeSetting.nightWorkRequired,
                allowShiftOvertime: storeSetting.allowShiftOvertime,
                allowWeeklyOvertime: storeSetting.allowWeeklyOvertime,
                shiftOvertimeOverride: storeSetting.shiftOvertimeOverride,
                weekOvertimeOverride: storeSetting.weekOvertimeOverride,
                enableAppShiftStatus: storeSetting.enableAppShiftStatus,
                enableCompanyEmail: storeSetting.enableCompanyEmail,
                enableWorkdayOvertime: storeSetting.enableWorkdayOvertime,
                allowFileUploadByEmployee: storeSetting.allowFileUploadByEmployee,
                enableMeo: storeSetting.enableMeo,
                enableVlh: storeSetting.enableVlh,
                useAvgWorkTimeForPrefs: storeSetting.useAvgWorkTimeForPrefs,
                noBreaks: storeSetting.noBreaks,
                appVacationDeadline: storeSetting.appVacationDeadline,
                enableAppCalculatedBalanceDisplay: storeSetting.enableAppCalculatedBalanceDisplay,
                allowedAppPreferenceTypes: storeSetting.allowedAppPreferenceTypes,
                allowedAppPreferenceSubtypes: storeSetting.allowedAppPreferenceSubtypes,
                minVacEmploymentDays: storeSetting.minVacEmploymentDays,
                aliquoteVac: storeSetting.aliquoteVac,
                enforceWageGroup: storeSetting.enforceWageGroup,
                aliquoteWorkTime: storeSetting.aliquoteWorkTime,
                federalState: storeSetting.federalState,
                requireActualShiftComment: storeSetting.requireActualShiftComment,
                enableAppChat: storeSetting.enableAppChat,
                shiftsOnHolidays: storeSetting.shiftsOnHolidays,
                autoResizeShifts: storeSetting.autoResizeShifts,
                appEmployeePreferencesDeadlineType: storeSetting.appEmployeePreferencesDeadlineType,
                enableAppVacReqYearLimit: storeSetting.enableAppVacReqYearLimit,
                minAppVacReqEmploymentDays: storeSetting.minAppVacReqEmploymentDays,
                useShiftStartForHolidayTime: storeSetting.useShiftStartForHolidayTime,

            }


            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {

                view.refresh(true);

                view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('store.settings.edited'));

                if(updateHolidays){
                    view.updateHolidayShiftCreationMode(shiftCreationMode);
                }

            }).catch(function(error) {
                view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('store.settings.editError'))

                console.log(error)
            })

        },
        updateHolidayShiftCreationMode(shiftCreationMode) {
            let view = this;
            let url = '/api/sec/storeevent/holidays';

            let params = {
                storeId: this.$store.state.storeId,
                
            }
            let payload = {
                id: "00000000-0000-0000-0000-000000000000",
                updateFields: ["shiftCreationMode"],
                shiftCreationMode: shiftCreationMode

            }
            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('store.events.holidayEditSucessful'));
                view.$store.commit('invalidateState', { states: [ 'holidayMapState' ] })


            }).catch(function(error) {
                view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('store.events.holidayEditError'))

                console.log(error)
            })
        },
        updateLawAbiding() {
            let view = this;
            let url = '/api/sec/storesettings/lawabiding';

            let params = {
                storeId: this.$store.state.storeId,
                value: !this.storeSettings.strictlyLawAbiding
            }


            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params
            }).then(response => {
                view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('store.settings.lawComplianceEdited'));
                view.refresh(true);


            }).catch(function(error) {
                view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('store.settings.lawComplianceEditError'))
                console.log(error)
            })
        },
        updateSimpleMode() {
            let view = this;
            let url = '/api/sec/storesettings/simplemode';

        let params = {
            storeId: this.$store.state.storeId,
            value: !this.storeSettings.simpleMode
        }


        this.axios({
            method: 'put',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            params: params
        }).then(response => {
            view.$helpers.success(view.$t('global.notifications.updateSuccessful'), view.$t('store.settings.simpleModeEdited'));
            view.refresh(true);


        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('store.settings.simpleModeEditError'))
            console.log(error)
        })
    },

    formatEmpApprovablePrefTypesArray(array){
        let result = "";
        if(array){
            array.forEach(e => {
                if(e == 1){result+="Urlaub "}
                else if(e == 2){result+="Krankheit "}
                else if(e == 3){result+="Feiertagsausgleich "}
                else if(e == 4){result+="Sonstiges "}
                else if(e == 6){result+="Pflegeurlaub "}
                else if(e == 7){result+="Ausbildung "}
                else if(e == 8){result+="Lohnfortzahlung "}
            })
        }

        return result;
    },

    openClearStoreDataModal: function($event){
        let view = this;

        let dataEntries = [
            {label: this.$t('store.settings.planingBaseDelete'), key: 'deleteEmployeeTypes', hidden: false, type: 'bool', value: false},
            {label: this.$t('store.settings.planingTemplateDelete'), key: 'deleteEmployeeTypeTemplates', hidden: false, type: 'bool', value: false},
            {label: this.$t('store.settings.leisureTimeOptionsDelete'), key: 'deleteEmployeeRules', hidden: false, type: 'bool', value: false},
            {label: this.$t('store.settings.leisureTemplatesDelete'), key: 'deleteEmployeeRuleTemplates', hidden: false, type: 'bool', value: false},
            {label: this.$t('store.settings.contractsDelete'), key: 'deleteEmployeeContracts', hidden: false, type: 'bool', value: false},
            {label: this.$t('store.settings.monthClosingsDelete'), key: 'deleteEmployeeWorkBalances', hidden: false, type: 'bool', value: false},
            {label: this.$t('store.settings.absencesDelete'), key: 'deleteEmployeePreferences', hidden: false, type: 'bool', value: false},
            {label: this.$t('store.settings.availabilities'), key: 'deleteEmployeeEmployeeAvailabilities', hidden: false, type: 'bool', value: false},
            {label: this.$t('store.settings.businessUnitsDelete'), key: 'deleteBusinessUnits', hidden: false, type: 'bool', value: false},
            {label: this.$t('store.settings.spotsDelete'), key: 'deleteSpots', hidden: false, type: 'bool', value: false},
            {label: this.$t('store.settings.skillsDelete'), key: 'deleteSkills', hidden: false, type: 'bool', value: false},
            {label: this.$t('store.settings.planShiftsDelete'), key: 'deletePlanShifts', hidden: false, type: 'bool', value: false},
            {label: this.$t('store.settings.punchedTimesDelete'), key: 'deleteActualShifts', hidden: false, type: 'bool', value: false},
            {label: this.$t('store.settings.shiftTemplatesDelete'), key: 'deleteShiftTemplates', hidden: false, type: 'bool', value: false},
            {label: this.$t('store.settings.holidaysDelete'), key: 'deleteHolidays', hidden: false, type: 'bool', value: false},
            {label: this.$t('store.settings.eventsDelete'), key: 'deleteStoreEvents', hidden: false, type: 'bool', value: false},
            {label: this.$t('global.ui.confirm'), key: 'confirmField', hidden: false, type: 'text', value: null},
        ];

            view.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                errorCheck: [
                    (entries) => {
                        if(view.storeSettings.name != entries.confirmField){
                            return {key: 'confirmField', type: 'error', label: this.$t('global.ui.confirm'), text: this.$t('store.settings.storeNameConfirmation')}
                        } else {
                            return null
                        }
                    },

                ],
                    selectCallback: function(data) {
                    if(view.storeSettings.name == data.confirmField){
                            view.clearStoreData(data);
                    }

                    }
                },
                header: this.$t('store.settings.deleteStoreData'),
                expanded: true,
                centered: true
            });
        },
        clearStoreData: function(payload) {


            let view = this;
            let url = '/api/sec/stores/cleardata';
            let params = {
                storeId: this.$store.state.storeId
            }

            this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload,
            }).then(response => {
                view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('store.settings.dataReset'))
            }).catch(function(error) {
                view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('store.settings.dataResetError'))
                console.log(error)
            })

        },
        resetUsageStartDateAndStoreData: function(storeSetting) {

            let view = this;
            let url = '/api/sec/stores/reset?storeId=' + this.$store.state.storeId;
            let date = this.$helpers.getMomentUTC().month(storeSetting.usageStartDate.month()).year(storeSetting.usageStartDate.year()).startOf('month');
            let payload = {
                usageStartDate: date.format(),
                deleteEmployeeWorkBalances: storeSetting.deleteEmployeeWorkBalances,
                deleteEmployeePreferences: storeSetting.deleteEmployeePreferences,
                deletePlanShifts: storeSetting.deletePlanShifts,
                deleteActualShifts: storeSetting.deleteActualShifts,
                deleteShiftTemplates: storeSetting.deleteShiftTemplates
            }

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {

                view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('store.settings.operationsEdit'))

                let settingMapItem = view.storeSettings;
                settingMapItem['usageStartDate'] = payload['usageStartDate'];
                view.$store.commit('setStoreSettings', { storeSettings: settingMapItem });
                view.$store.commit("invalidateState", { states: ['planShiftMapState', 'employeePreferenceMapState', 'employeeContractMapState', 'employeeWorkbalanceMapState', 'employeeMapState', 'employeeAvailabilityMapState'] });

            }).catch(function(error) {
                view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('store.settings.operationsEditError'))
                console.log(error)
            })

        },
        openTransferModal(employee) {
            let view = this;
            let description = this.$t('store.settings.dataCopyQuery') + " <br/>";
            let dataOptions = [];
            if(this.isSuperUser){
                dataOptions = [{ label: this.$t('store.collectiveContracts.title'), value: 0 },
                    { label: this.$t('store.settings.businessUnitSpots'), value: 1 },
                    { label: this.$tc('global.general.employee'), value: 2 },
                    { label: this.$t('store.settings.deactivatedEmployees'), value: 6 },
                    { label: this.$t('store.settings.shiftTemplates'), value: 3 },
                    { label: this.$t('store.settings.employeeFiles'), value: 4 },
                    { label: this.$t('store.settings.plannedKeyFigures'), value: 5 },
                    { label: this.$t('store.settings.accountingPeriodSettings'), value: 7 },
                    { label: this.$t('store.settings.contractExitSettings'), value: 8 },
                    { label: this.$t('store.settings.roles'), value: 9 },
                    { label: this.$t('workBalance.bonus.title'), value: 10 },
                ]
            } else {
                dataOptions = [
                    { label: this.$t('store.collectiveContracts.title'), value: 0 },
                    { label: this.$t('store.settings.accountingPeriodSettings'), value: 7 },
                    { label: this.$t('store.settings.contractExitSettings'), value: 8 },
                    { label: this.$t('store.settings.roles'), value: 9 },
                    { label: this.$t('workBalance.bonus.title'), value: 10 },
                ]
            }
            
            let storeItems = this.selectableStores.map(i => {
                return { label: i.label, value: i }
            });
            let dataEntries = [];
            dataEntries.push(
                {
                    label: this.$t('store.settings.data'),
                    key: 'data',
                    hidden: false,
                    type: 'dropdownsearch',
                    value: null,
                    selectMultiple: false,
                    flexGroup: false,
                    dropdownSearchState: {
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: dataOptions,
                        selectMultiple: false,
                        selectFirst: true,
                        selectedItems: [],
                        selectedItem: {},
                        onceSelected: function($event, item, searchbar) {
                        },
                        styleLight: true,
                        placeholder: this.$t('store.settings.dataSelect'),
                    }
                },
                {
                    label: this.$t('store.settings.shifts'),
                    key: 'withShifts',
                    hidden: true,
                    type: 'bool',
                    value: false,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let dataValue = datafill.entries.find(i => i.key == 'data').value;
                        if (dataValue == 3) {
                            entryBeforeUpdate.hidden = false;
                        } else {
                            entryBeforeUpdate.value = false;
                            entryBeforeUpdate.hidden = true;
                        }

                        return entryBeforeUpdate;
                    }
                },
                {
                    label: this.$t('store.settings.transferUserRoles'),
                    key: 'transferUserRoles',
                    hidden: true,
                    type: 'bool',
                    value: false,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                        let dataValue = datafill.entries.find(i => i.key == 'data').value;
                        if (dataValue == 9) {
                            entryBeforeUpdate.hidden = false;
                        } else {
                            entryBeforeUpdate.value = false;
                            entryBeforeUpdate.hidden = true;
                        }

                        return entryBeforeUpdate;
                    }
                },
                {
                    label: this.$tc('global.menubar.store'),
                    key: 'store',
                    hidden: false,
                    type: 'dropdownsearch',
                    value: null,
                    selectMultiple: false,
                    flexGroup: false,
                    dropdownSearchState: {
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: storeItems,
                        selectMultiple: false,
                        selectedItems: [],
                        selectedItem: {},
                        onceSelected: function($event, item, searchbar) {
                        },
                        styleLight: true,
                        placeholder: this.$t('store.settings.storeSelect'),
                    }
                },
                {
                    label: this.$t('store.settings.date'),
                    key: 'date',
                    hidden: !this.isSuperUser,
                    type: 'date',
                    value: view.$helpers.getMomentTZ().startOf('month').add(1, 'months'),
                    flexGroup: false
                },
            {label: this.$t('global.ui.confirm'), key: 'confirmField', hidden: false, type: 'text', value: null},
            {label: this.$t('global.ui.confirmTarget'), key: 'confirmField2', hidden: false, type: 'text', value: null},
            );
            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                errorCheck: [
                    (entries) => {

                        if(view.storeSettings.id == entries.store.id){
                            return {key: 'store', type: 'error', label: this.$tc('global.menubar.store'), text: 'Der Ziel-Betrieb kann nicht gleich dem Quell-Betrieb sein!'}
                        } else {
                            return null
                        }
                    },
                    (entries) => {

                        if(view.storeSettings.name != entries.confirmField){
                            return {key: 'confirmField', type: 'error', label: this.$t('global.ui.confirm'), text: this.$t('store.settings.storeNameConfirmation')}
                        } else {
                            return null
                        }
                    },
                    (entries) => {

                        if(entries.store != null && entries.confirmField2 != entries.store.label.trim()){
                            return {key: 'confirmField2', type: 'error', label: this.$t('global.ui.confirmTarget'), text: 'Bitte geben Sie die den Namen des Ziel-Stores als Bestätigung ein'}
                        } else {
                            return null
                        }
                    },

                ],
                    description: description,
                    selectCallback: function(data) {
                    if(data.confirmField2 == data.store.label && view.storeSettings.name == data.confirmField){
                            let payload = {}

                            if (data.store) {
                                payload.targetStoreId = data.store.id;
                                payload.targetCompanyId = data.store.companyId;
                            }
                            if (data.data == 0) {
                                view.transferAllowedContracts(payload);
                            } else if (data.data == 1) {
                                view.transferBusinessUnits(payload);
                            } else if (data.data == 2) {
                                payload.copyContract = true;
                                payload.copyWorkBalances = false;
                                payload.copyEmployeePreferences = true;
                                payload.copyEmployeeTypes = true;
                                payload.copyEmployeeFiles = false;
                                payload.copyEmployeeRules = true;
                                payload.active = true;
                                payload.ewbToDate = data.date.format();
                                view.transferEmployees(payload);
                            } else if (data.data == 6) {
                                payload.copyContract = true;
                                payload.copyWorkBalances = false;
                                payload.copyEmployeePreferences = true;
                                payload.copyEmployeeTypes = false;
                                payload.copyEmployeeFiles = false;
                                payload.copyEmployeeRules = false;
                                payload.active = false;
                                payload.ewbToDate = data.date.format();
                                view.transferEmployees(payload);
                            } else if (data.data == 3) {
                                payload.withShifts = data.withShifts;
                                payload.date = data.date.format();
                                view.transferShiftTemplates(payload);
                            } else if (data.data == 4) {
                                view.transferEmployeeFiles(payload);
                            } else if (data.data == 5) {
                                payload.date = data.date;
                                view.transferPlanningIndicators(payload);
                            } else if(data.data == 7){
                                view.transferAccountingPeriodSettings(payload);
                            } else if(data.data == 8){
                                view.transferContractExitSettings(payload);
                            } else if(data.data == 9){
                                payload.transferUserRoles = data.transferUserRoles;
                                view.transferRoles(payload);
                            } else if(data.data == 10){
                                view.transferBonusPaymentSettings(payload);
                            }
                    }

                    }
                },
                header: this.$t('store.settings.dataCopy'),
                width: '700px',
                expanded: true,
                centered: true
            });

        },
        transferAllowedContracts(data) {

            let view = this;
            view.transferring = true;
            let url = '/api/sec/allowedcontract/transfer';

            let params = {
                storeId: view.$store.state.storeId,
            }
            let payload = {
                targetStoreId: data.targetStoreId,
                targetCompanyId: data.targetCompanyId,
            }
            view.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + view.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.transferring = false;
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('store.settings.collectiveContractsCopy'));

            }).catch(function(error) {
                view.transferring = false;
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.settings.collectiveContractsCopyError'));
            });
        },
        transferBusinessUnits(data) {

            let view = this;
            view.transferring = true;
            let url = '/api/sec/businessunit/transfer';

            let params = {
                storeId: view.$store.state.storeId,
            }
            let payload = {
                targetStoreId: data.targetStoreId,
                targetCompanyId: data.targetCompanyId,
            }
            view.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + view.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.transferring = false;
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('store.settings.busCopy'));

            }).catch(function(error) {
                view.transferring = false;
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.settings.busCopyError'));
            });
        },
        transferShiftTemplates(data) {

            let view = this;
            view.transferring = true;
            let url = '/api/sec/shifttemplate/transfer';

            let params = {
                storeId: view.$store.state.storeId,
            }
            let payload = {
                targetStoreId: data.targetStoreId,
                targetCompanyId: data.targetCompanyId,
                withShifts: data.withShifts,
                date: data.date
            }
            view.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + view.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.transferring = false;
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('store.settings.shiftTemplateCopy'));

            }).catch(function(error) {
                view.transferring = false;
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.settings.shiftTemplateCopyError'));
            });
        },
        transferAccountingPeriodSettings(data) {

            let view = this;
            view.transferring = true;
            let url = '/api/sec/accountingperiodsetting/transfer';

            let params = {
                storeId: view.$store.state.storeId,
            }
            let payload = {
                targetStoreId: data.targetStoreId
            }
            view.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + view.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.transferring = false;
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('store.settings.accountingPeriodSettingsCopy'));

            }).catch(function(error) {
                view.transferring = false;
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.settings.accountingPeriodSettingsCopyError'));
            });
        },
        transferContractExitSettings(data) {

            let view = this;
            view.transferring = true;
            let url = '/api/sec/contractexitsetting/transfer';

            let params = {
                storeId: view.$store.state.storeId,
            }
            let payload = {
                targetStoreId: data.targetStoreId
            }
            view.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + view.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.transferring = false;
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('store.settings.contractExitSettingsCopy'));

            }).catch(function(error) {
                view.transferring = false;
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.settings.contractExitSettingsCopyError'));
            });
        },
        transferRoles(data) {

            let view = this;
            view.transferring = true;
            let url = '/api/sec/role/transfer';

            let params = {
                storeId: view.$store.state.storeId,
            }
            let payload = {
                targetStoreId: data.targetStoreId,
                transferUserRoles: data.transferUserRoles != null ? data.transferUserRoles : false,
            }
            view.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + view.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.transferring = false;
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('store.settings.roleCopy'));

            }).catch(function(error) {
                view.transferring = false;
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.settings.roleCopyError'));
            });
        },
        transferBonusPaymentSettings(data) {

            let view = this;
            view.transferring = true;
            let url = '/api/sec/bonuspaymentsetting/transfer';

            let params = {
                storeId: view.$store.state.storeId,
            }
            let payload = {
                targetStoreId: data.targetStoreId
            }
            view.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + view.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.transferring = false;
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('store.settings.bonusPaymentCopy'));

            }).catch(function(error) {
                view.transferring = false;
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.settings.bonusPaymentCopyError'));
            });
        },
        transferEmployees(data) {

            let view = this;
            view.transferring = true;
            let url = '/api/sec/employee/transfer/multiple';

            let params = {
                storeId: view.$store.state.storeId,
            }
            let payload = {
                targetStoreId: data.targetStoreId,
                targetCompanyId: data.targetCompanyId,
                copyContract: data.copyContract,
                copyWorkBalances: data.copyWorkBalances,
                copyEmployeePreferences: data.copyEmployeePreferences,
                copyEmployeeTypes: data.copyEmployeeTypes,
                copyEmployeeRules: data.copyEmployeeRules,
                copyEmployeeFiles: data.copyEmployeeFiles,
                ewbToDate: data.ewbToDate,
                active: data.active,

            }
            view.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + view.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.transferring = false;
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('store.settings.employeeCopy'));

            }).catch(function(error) {
                view.transferring = false;
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.settings.employeeCopyError'));
            });
        },
        transferEmployeeFiles(data) {

            let view = this;
            view.transferring = true;
            let url = '/api/sec/employeefile/transfer';

            let params = {
                storeId: view.$store.state.storeId,
            }
            let payload = {
                targetStoreId: data.targetStoreId,
            }
            view.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + view.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.transferring = false;
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('store.settings.employeeFilesCopy'));

            }).catch(function(error) {
                view.transferring = false;
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.settings.employeeFilesCopyError'));
            });
        },
        transferPlanningIndicators(data) {

            let view = this;
            view.transferring = true;
            let url = '/api/sec/planningindicator/storetransfer';

            let params = {
                storeId: view.$store.state.storeId,
            }
            console.log(data.date);
            let payload = {
                targetStoreId: data.targetStoreId,
                from: data.date.format(),
                to: data.date.clone().add(1, 'months').format()
            }
            view.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + view.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.transferring = false;
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('store.settings.keyFiguresCopy'));

            }).catch(function(error) {
                view.transferring = false;
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.settings.keyFiguresCopyError'));
            });
        },
        openUnlinkAccountsModal(employee) {
            let view = this;
            
            
            let dataEntries = [];
            dataEntries.push(
                
            {label: this.$t('global.ui.confirm'), key: 'confirmField', hidden: false, type: 'text', value: null},
            
            );
            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    errorCheck: [
                        (entries) => {

                            if(view.storeSettings.name != entries.confirmField){
                                return {key: 'confirmField', type: 'error', label: this.$t('global.ui.confirm'), text: this.$t('store.settings.storeNameConfirmation')}
                            } else {
                                return null
                            }
                        },
                        

                    ],
                    
                    selectCallback: function(data) {
                        if(view.storeSettings.name == data.confirmField){
                            view.unlinkEmployeeAccounts(); 
                        }

                    }
                },
                header: this.$t('store.settings.unlinkEmployeeAccounts'),
                expanded: true,
                centered: true
            });

        },
        unlinkEmployeeAccounts() {

            let view = this;
            
            let url = '/api/sec/employee/unlinkaccount/all';

            let params = {
                storeId: view.$store.state.storeId,
            }
           
            view.axios({
                method: 'put',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + view.$store.state.jwt
                },
                url: url,
            }).then(response => {
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('store.settings.unlinkEmployeeAccountsSuccess'));

            }).catch(function(error) {
                view.transferring = false;
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.settings.unlinkEmployeeAccountsError'));
            });
        },
        openExcelImportModal: function() {
            this.modalImportCsv = true;
        },

        openUpdateUsageStartDateModal: function() {
            this.showModal('modal-usagestartdate');
        },
        importExcelPayload: function() {
            let view = this;
            if (this.excelPayloadFile != null) {
                let reader = new FileReader();

                // Closure to capture the file information.
                reader.onload = (file => {
                    let text = file.target.result;

                    // parse as JSON
                    let payload = JSON.parse(text);
                    let url = '/api/sec/import/excel';
                    let params = {
                        storeId: this.$store.state.storeId
                    }

                    this.axios({
                        method: 'post',
                        params: params,
                        headers: {
                            'AUTHORIZATION': "bearer " + this.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    }).then(response => {

                        view.$helpers.success(view.$t('store.settings.importSuccessful'), view.$t('store.settings.importSuccessfulMsg'))


                        this.modalImportCsv = false;


                    }).catch(function(error) {
                        view.$helpers.error(view.$t('store.settings.importError'), view.$t('store.settings.importErrorMsg'))
                        console.log(error)
                    })

                });

                // Read in the image file as a data URL.
                reader.readAsText(this.excelPayloadFile);

            } else {
                view.$helpers.error(view.$t('store.settings.importError'), view.$t('store.settings.importErrorMsgData'))
                this.modalImportCsv = false;
            }
        },
        loadStoreExternalData: function() {
            let url = '/api/sec/storeexternaldata';

            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/storeexternaldata');

            return this.axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            });
        },
        updateStoreExternalData: function(data) {
            let edataMap = {};

            data.forEach((item) => {
                edataMap[item.id] = item;
            });

            this.externalDataMap = edataMap;
        },
        loadSotecApiData: function() {
            let url = '/api/sec/sotecapidata';

            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/sotecapidata');

            return this.axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            });
        },
        updateSotecApiData: function(data) {
            let edataMap = {};

            data.forEach((item) => {
                edataMap[item.id] = item;
            });

            this.sotecApiDataMap = edataMap;
        },
        loadPlanningIndicatorTypes: function() {

            let url = '/api/sec/planningindicatortype';

            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/planningindicatortype');


            return this.axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            })

        },
        updatePlanningIndicatorTypes: function(data) {

            let map = {};
            for (let i = 0; i < data.length; i++) {
                map[data[i].id] = data[i];
            }
            this.planningIndicatorTypeMap = map;
        },

        hideModalWithoutReset(ref) {
            this.$refs[ref].hide();
        },
        hideModal(ref) {
            this.$refs[ref].hide()
        },
        showModal(ref) {
            this.$refs[ref].show()
        }
    },


}
</script>


<style scoped>
.has-header > .has-header > .scrollbar-container {
    height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
    overflow-x: hidden;
    top: var(--header-height);
    padding: 0px 14px;
}

.page-settings {
    top: 0px !important;
}

.md-card {
    position: fixed;
    z-index: 1000000;
    width: calc(60% - 18px);
    padding-bottom: 10px;
    top: 135px;
    left: 20%;
    right: auto;
    resize: both;
    overflow: hidden;
}

.md-card.xl {
    width: calc(80% - 18px);
    left: 10%;
}

.md-card-body {
    max-height: calc(98vh - 139px);
    overflow-x: auto;
}

.md-card-select {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: left;
    align-items: normal;
    padding-bottom: 16px;
    margin-bottom: 16px;
}

.md-card-select.noborder {
    padding-bottom: 0px;
}

.md-card-select .label {
    width: 140px;
    margin-top: 0;
}

.md-card-select .auto-label {
    width: auto;
}

.cd-input {
    margin: -2px 0;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: left;
    align-items: center!important;
    padding-bottom: 6px;
}

.cd-input:not(.roinput) > input {
    width: 320px;
}

</style>
